import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { apiCall, removeParam, getBaseDir, getPaymentMethod, moeda2float, disableForm, enableForm, float2moeda, userHasRole, getBusinessDoctorsListByBranchId, userHasBranch } from '../../utils.js';
import Swal from 'sweetalert2';
import TableBuilder from '../../table_builder.js';
import moment from 'moment-timezone';
const XLSX = require('xlsx');


const tableRef = new TableBuilder({
  table: '#table-sales-list',
  tableBody: '.js-sales-registrations-table',
  data: [],
  rowsPerPage: 10,
  filter: false,
  maxPages: 0,
  footerWithId: false,
  tableRowRenderer: function (rowData, opts) {
    return mountTableRow(rowData, opts);
  },
});

// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-page-${tableRef.getTableId()}`, function (e) {
  e.preventDefault();
  let pageId = $(this).text();
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});
// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-previous-page-${tableRef.getTableId()}`, function (e) {
  e.preventDefault();
  let pageId = tableRef.getCurrentPage() - 1; //console.log('previous pageId', pageId);
  if (pageId <= 0)
    return;
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});
// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-next-page-${tableRef.getTableId()}`, function (e) {
  e.preventDefault();
  let pageId = tableRef.getCurrentPage() + 1; //console.log('next pageId', pageId);
  if (pageId > tableRef.getMaxPages())
    return;
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});

const mountTableRow = (rowData) => {
  let url = getBaseDir() + 'pacientes/cadastros?' + $.param({
    patient_id: rowData.CLIENTE_ID,
    branch: rowData.FILIAL
  });

  return `
    <tr class="js-view-sale-details-row" data-id="${rowData.ID}">
      <td><div class="form-check"><input type="checkbox" class="form-check-input js-create-sale-item-checkbox" data-id="${rowData.ID}" /></div></td>
      <td data-label="Filial">${rowData.FILIAL}</td>
      <td data-label="Número">${rowData.ID}</td>
      <td data-label="Data">${moment(rowData.DATA_VENDA).tz("America/Sao_Paulo").format('DD/MM/YYYY')}</td>
      <td data-label="Cliente"><a href="${url}" target="new">${rowData.CLIENTE_NOME}</a></td>
      <td data-label="Valor (R$)">${float2moeda(rowData.VALOR_TOTAL)}</td>
      <td data-label="Situação">${renderSellStatus(rowData.STATUS)}</td>
      <td data-label="Nota Fiscal"><button type="button" class="btn btn-sm btn-outline-primary js-sale-invoice-emission" data-sale-info='${JSON.stringify(rowData)}'>${rowData.NOTA_FISCAL_ID ? `${rowData.NOTA_FISCAL_RPS} - ${rowData.NOTA_FISCAL_NUMERO}` : 'Gerar NFS-e'}</button></td>
      <td data-label="Ações">
        <!-- botão ações -->
        <div class="dropdown">
          <button class="btn btn-sm btn-secondary dropdown-toggle js-sale-actions-button" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Ações
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item js-sale-actions-button-edit" data-id="${rowData.ID}" href="#">Editar</a>
            <a class="dropdown-item d-none" href="#">Clonar</a>
            <a class="dropdown-item d-none" href="#">Imprimir</a>
            ${rowData.STATUS == 'EM_ABERTO' || rowData.STATUS == 'STONE_EM_LANCAMENTO' ? `<a class="dropdown-item js-sale-actions-button-delete" data-id="${rowData.ID}" href="#">Cancelar</a>` : ''}
          </div>
        </div>
      </td>
    </tr>
  `
}

// Render sell status
const renderSellStatus = (status) => {
  switch (status) {
    case 'EM_ABERTO': return '<div class="badge bg-info">Em aberto</div>';
    case 'APROVADO': return '<div class="badge bg-success">Aprovado</div>';
    case 'STONE_EM_LANCAMENTO': return '<div class="badge bg-warning">Stone: Em lançamento</div>';
    case 'CANCELADA': return '<div class="badge bg-danger">Cancelada</div>';
    case 'CANCELADA_ERRO_LANCAMENTO': return '<div class="badge bg-danger">Cancelada por erro de lançamento</div>';
  }
}
window.renderSellStatus = renderSellStatus;

const renderInstallmentStatus = (status, conciliado) => {
  if (!conciliado) {
    switch (status) {
      case null: return '<div class="badge bg-warning">Em aberto</div>';
      case true: return '<div class="badge bg-success">Recebido</div>';
      case 'CONCILIADO': return '<div class="badge bg-success" data-tippy-content="Essa parcela possui um recebimento conciliado">Recebido <i class="fa fa-check-circle"></i></div>';
      default: return '<div class="badge bg-success">Recebido</div>';
    }
  } else {
    return '<div class="badge bg-success" data-tippy-content="Essa parcela possui um recebimento conciliado">Recebido <i class="fa fa-check-circle"></i></div>';
  }
}

const PatientsReports = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [branches, setBusinessBranches] = useState([]);
  const [invoiceQueueData, setInvoiceQueueData] = useState(null);
  const [formData, setFormData] = useState({
    branch: '',
    branchName: '',
    startDate: '',
    endDate: '',
    reportType: '',
    recordsPerPage: 25,
    page: 1
  })
  const interval = useRef(null);
  const searchQueryTimeout = useRef(null);
  const createSaleCustomerData = useRef(null);
  const createSaleFormData = useRef(null);
  const createSaleIsEdit = useRef(false);
  const viewSale = useRef(false);
  const viewSaleData = useRef(false);
  const currentAcquirerersData = useRef(null);
  const currentInstallmentId = useRef(null);
  const currentInvoiceData = useRef(null);
  const invoiceEmissionInterval = useRef(null);
  const isViewingInvoiceQueue = useRef(false);
  const invoiceQueueInterval = useRef(null);
  const invoiceQueueXHR = useRef(null);
  const stoneOrderPaymentCheckInterval = useRef(null);
  const stoneOrderPaymentCheckXHR = useRef(null);
  const saleCheckerIntv = useRef(null);

  const initData = () => {
    let userProfileResponse = { ...window._sessionData };
    setBusinessBranches(userProfileResponse.businessBranches);
    clearInterval(interval.current);
    fetchTableData();
    handleTableFilterChange();

    handleSaleCreateModal();
    handleSaleCreateAddItem();
    handleSaleCreateAddPaymentMethods();
    handleSaleInstallmentAcquittance();
    handleSaleInvoiceEmission();
    handleGenerateCorrenteOrContract();
    handleSaleInvoiceEmissionQueue();
    handleStoneIntegrationScreenInputs();
  }

  // Detecta alteração nos filtros da tabela
  const handleTableFilterChange = () => {
    $('.js-sales-registrations-branches-selector, .js-sales-registrations-start-date-input, .js-sales-registrations-end-date-input, #js-sales-registrations-search-input').on('change', function () {
      // debounce
      clearTimeout(searchQueryTimeout.current);
      searchQueryTimeout.current = setTimeout(function () {
        fetchTableData();
      }, 1000);
    });

    $(document).on('change', '.js-sales-per-page', function () {
      setTableCurrentPage(parseInt($(this).val()))
    });

    $('#js-sales-registrations-search-input').on('keyup', function () {
      clearTimeout(searchQueryTimeout.current);
      searchQueryTimeout.current = setTimeout(function () {
        fetchTableData();
      }, 1000);
    });

    $(document).on('click', '.js-create-sale-item-checkbox', function (e) {
      e.stopPropagation();
      //console.log('change create sale item checkbox', $(this).data('id'));
    });

    $(document).on('change', '#js-sales-registrations-show-pending-invoices-checkbox', function () {
      fetchTableData();
    });

    $(document).on('click', '#js-sales-registrations-show-all-period-checkbox', function () {
      fetchTableData();
    });

    $(document).on('click', '#js-sales-registrations-show-subscription-only-checkbox', function () {
      fetchTableData();
    });
  }

  const setTableCurrentPage = (page_id) => {
    tableRef.setRowsPerPage(page_id);
    tableRef.setCurrentPage(1);
    fetchTableData();
  }

  // Busca os dados da tabela
  const fetchTableData = (pageId = false) => {

    $(".js-sales-registrations-table").block(window._loader.loading);

    let formData = {
      ...($('.js-sales-registrations-branches-selector').val() ? { branch: $('.js-sales-registrations-branches-selector').val() } : {}),
      ...($('.js-sales-registrations-start-date-input').val() ? { startDate: $('.js-sales-registrations-start-date-input').val() } : {}),
      ...($('.js-sales-registrations-end-date-input').val() ? { endDate: $('.js-sales-registrations-end-date-input').val() } : {}),
      ...($('.js-sales-per-page').val() ? { recordsPerPage: $('.js-sales-per-page').val() } : {}),
      ...($('#js-sales-registrations-search-input').val() ? { searchTerm: $('#js-sales-registrations-search-input').val() } : {}),
      ...($('#js-sales-registrations-show-pending-invoices-checkbox').is(':checked') ? { showPendingInvoices: $('#js-sales-registrations-show-pending-invoices-checkbox').is(':checked') } : {}),
      ...($('#js-sales-registrations-show-all-period-checkbox').is(':checked') ? { showAllPeriod: $('#js-sales-registrations-show-all-period-checkbox').is(':checked') } : {}),
      ...($('#js-sales-registrations-show-subscription-only-checkbox').is(':checked') ? { subscriptionOnly: $('#js-sales-registrations-show-subscription-only-checkbox').is(':checked') } : {})
    }
    if (pageId) {
      formData.page = pageId;
      setFormData(formData);
      window.localStorage.setItem('patientsReportsFormData', JSON.stringify(formData));
    }

    setIsLoading(true);

    apiCall({
      endpoint: 'api/v1/sales',
      method: 'GET',
      data: {
        ...formData
      },
      successCallback: (response) => {
        //console.log('response', response);

        /*setIsLoading(false);*/
        setFormData(formData);
        window.localStorage.setItem('createSaleFormData', JSON.stringify(formData));

        setTimeout(() => { tableRef.renderPage(tableRef.getCurrentPage(), false, response.data, false, response.total) }, 1000);

        $('.js-sales-total-sales-period-count').html(response.total);
        $('.js-sales-total-sales-value').html(float2moeda(response.sold_value));

        $('.js-sales-total-sales-approved-count').html(response.total_approved_count);
        $('.js-sales-total-sales-approved-value').html(float2moeda(response.sold_value_approved));

        $('.js-sales-total-sales-canceled-count').html(response.total_canceled_count);
        $('.js-sales-total-sales-canceled-value').html(float2moeda(response.sold_value_canceled));

        $(".js-sales-registrations-table").unblock();
      },
      errorCallback: (err) => {
        setIsLoading(false);
        console.error('error', err);
        $(".js-sales-registrations-table").unblock();
      }
    });
  }

  // Detecta cliques no modal de criação de venda
  const handleSaleCreateModal = () => {

    function OnDoctorsReady() {
      if (createSaleIsEdit.current) {
        $('#create-sale-seller').val(createSaleFormData.current.sellerId).trigger('select2:select');
        //console.log('loaded seller', createSaleFormData.current.sellerId);
      }
    }
    window.doctorsReadyFunctions.push(OnDoctorsReady);

    // Detecta clique na linha da tabela de vendas no botão de ações para evitar propagação
    $(document).on('click', '.js-sale-actions-button', function (e) {
      e.stopPropagation();
    });

    // Detecta clique no botão de Ações de uma parcela
    $(document).on('click', '.js-sale-view-installment-details', function (e) {
      e.stopPropagation();
    });

    $('.js-view-sale-edit-mode').on('click', function (e) {
      //console.log('click js-view-sale-edit-mode');
      let saleId = $(this).data('id');
      $('#modal-sale-create').addClass('child-modal');
      //console.log('saleId', saleId);
      if (current)
        OnOpenSaleEditMode(e, saleId);
    });

    // Detecta clique no botão de criar nova venda
    $(document).on('click', '.js-sales-create-new,.js-sale-actions-button-edit', function (e) {
      let saleId = $(this).data('id');
      OnOpenSaleEditMode(e, saleId);
    });

    // Detecta clique no botão de cancelar uma venda
    $(document).on('click', '.js-sale-actions-button-delete', function (e) {
      e.stopPropagation();
      OnOpenSaleCancelMode($(this).data('id'));
    });

    // Detecta clique em uma venda para ver detalhes
    $(document).on('click', '.js-view-sale-details-row', function () {
      let isEditSaleId = $(this).data('id');
      if (isEditSaleId) {
        //createSaleIsEdit.current = isEditSaleId;
        $('#modal-sale-details').modal('show');
        $('#modal-sale-details').block(window._loader.loading);
        viewSale.current = isEditSaleId;
        OnOpenSaleViewMode();
      }
    });

    // Detecta clique na linha de uma parcela (dentro modal de detalhes)
    $(document).on('click', '.js-sale-view-installment-row', function (e) {
      e.stopPropagation();
      //console.log('view installment details', $(this).data('installment-id'))
      OnOpenInstallmentViewMode($(this).data('installment-id'));
    });

    // Detecta clique no botão de editar uma parcela (dentro modal de detalhes > ações)
    $(document).on('click', '.js-sale-view-installment-edit', function (e) {
      e.stopPropagation();
      //console.log('edit installment', $(this).data('installment-id'))
    });

    // Detecta clique no botão de informar recebimento de uma parcela (dentro modal de detalhes > ações)
    $(document).on('click', '.js-sale-view-acquittance-edit,.js-sale-installment-acquittance', function (e) {
      e.stopPropagation();
      if (viewSaleData.current) {
        if (viewSaleData.current.stone && (!userHasRole('ADMIN') || !userHasRole('ADMIN_ASSISTANT'))) {
          return window.toast({
            error: true,
            text: 'Seu nível de usuário não permite informar recebimento de uma parcela de uma venda com stone.'
          })
        }
      }
      //console.log('edit acquittance', $(this).data('installment-id'), $(this).data('acquittance-id'))
      OnOpenAcquittanceViewMode($(this).data('installment-id'), $(this).data('acquittance-id'));
    });

    // Seleciona a filial
    $('#create-sale-branch').select2({
      placeholder: "Selecione a filial",
      theme: 'bootstrap-5',
      dropdownParent: $(".js-create-sale-branch-container"),
    });

    // Detecta alteração na seleção da filial
    $('#create-sale-branch').on('select2:select', function (e) {
      if (!e.params) {
        e.params = {
          data: {
            id: parseInt(createSaleFormData.current.branch)
          }
        }

        $(`#create-sale-customer`).html(`<option value="${createSaleCustomerData.current.id}" selected>${createSaleCustomerData.current.name}</option>`);
        $(`#create-sale-customer`).val(createSaleCustomerData.current.id).trigger('select2:select');
        setTimeout(() => {
          $('#create-sale-seller').val(createSaleFormData.current.sellerId).trigger('select2:select');
        }, 1000);
        $('#create-sale-date').val(createSaleFormData.current.date);
        $('#create-sale-notes').val(createSaleFormData.current.notes);
      } else {
        let branchId = parseInt(e.params.data.id);
        createSaleFormData.current.branch = branchId;

        let stoneInfo = Object.values(window._sessionData.allBranches).find((value) => value.ID == branchId).METADATA.integrations?.stone;
        createSaleFormData.current.stone = /*stoneInfo ? true :*/ false;

        if (createSaleFormData.current.stone) {
          //createSaleFormData.current.stoneSaleId = null;
          createSaleFormData.current.stoneCurrentOrderId = null;
          createSaleFormData.current.isCreatingStoneOrder = false;

          $('.js-create-sale-discount-area').addClass('d-none');
        } else {
          $('.js-create-sale-discount-area').removeClass('d-none');
        }

        if (createSaleFormData.current.paymentMethods.length > 0) {
          createSaleFormData.current.paymentMethods = [];
          renderSaleCreatePaymentMethods(true);
        }

        console.log('stoneInfo', stoneInfo);
        console.log('createSaleFormData.current', createSaleFormData.current);

        $('#create-sale-customer').prop('disabled', false);
        $('#create-sale-seller').prop('disabled', false);
        $('#create-sale-date').prop('disabled', false);
        $('#create-sale-financial-category').prop('disabled', false);
        $('#create-sale-financial-cost-center').prop('disabled', false);
        $('#add-create-sale-button').prop('disabled', false);
        $('#create-sale-payment-method').prop('disabled', false);
        $('#create-sale-notes').prop('disabled', false);
      }
      renderSaleCreationErrors();
    });

    // Limpa a seleção da filial
    $('.js-create-sale-branch-clear-button').on('click', function () {
      if (createSaleIsEdit.current) {
        if (createSaleFormData.current.status != 'EM_ABERTO') {
          return window.toast({
            error: true,
            text: 'Não é possível limpar o item pois a venda já foi criada.'
          });
        }
      }
      $('#create-sale-branch').val('').trigger('change');
      $('#create-sale-customer').val('').trigger('change');
      createSaleFormData.current.customerId = -1;
      createSaleFormData.current.branch = -1;
      $('#create-sale-customer').prop('disabled', true);
      $('#create-sale-seller').prop('disabled', true);
      $('#create-sale-date').prop('disabled', true);
      $('#add-create-sale-button').prop('disabled', true);
      $('#create-sale-payment-method').prop('disabled', true);
      $('#create-sale-financial-category').prop('disabled', true);
      $('#create-sale-financial-cost-center').prop('disabled', true);
      $('#create-sale-notes').prop('disabled', true);
      renderSaleCreationErrors();
    });

    // Seleciona o vendedor
    $('#create-sale-seller').select2({
      placeholder: "Selecione o vendedor",
      theme: 'bootstrap-5',
      dropdownParent: $(".js-create-sale-seller-container"),
    });

    // Detecta alteração na seleção do vendedor
    $('#create-sale-seller').on('select2:select', function (e) {
      if (e.params) {
        createSaleFormData.current.sellerId = parseInt(e.params.data.id);
      }
      renderSaleCreationErrors();
    });

    // Limpa a seleção do vendedor
    $('.js-create-sale-seller-clear-button').on('click', function () {
      if (createSaleIsEdit.current) {
        if (createSaleFormData.current.status != 'EM_ABERTO') {
          return window.toast({
            error: true,
            text: 'Não é possível limpar o vendedor pois a venda já foi criada.'
          });
        }
      }
      $('#create-sale-seller').val('').trigger('change');
      createSaleFormData.current.sellerId = -1;
      renderSaleCreationErrors();
    });

    // Seleciona o cliente
    $('#create-sale-customer').select2({
      placeholder: "Busque por telefone, nome ou email",
      theme: 'bootstrap-5',
      dropdownParent: $(".js-create-sale-customer-container"),
      minimumInputLength: 3,
      ajax: {
        url: getBaseDir() + 'api/v1/patient/search',
        delay: 1000,
        data: function (params) {
          var query = {
            search: params.term,
            branchId: createSaleFormData.current.branch || -1,
            page: params.page || 1
          }
          // Query parameters will be ?search=[term]&page=[page]
          return query;
        },
        processResults: function (data, params) {
          params.page = params.page || 1;

          var results = [];
          $.each(data.results, function (k, v) {
            if (v.CADASTRO_COMPLETO == 'S') {
              results.push({
                id: v.ID,
                text: `${v.TEXT}${v.CPF != null ? ` - ${v.CPF}` : ` - ${v.PASSAPORTE}`}`,
                info: v
              });
            }
          });

          // Transforms the top-level key of the response object from 'items' to 'results'
          return {
            results: results,
            pagination: {
              more: (params.page * 10) < data.count_filtered
            }
          };
        }
      }
    });

    // Detecta alteração na seleção do cliente
    $('#create-sale-customer').on('select2:select', function (e) {
      if (e.params) {
        createSaleCustomerData.current = e.params.data.info;
        createSaleFormData.current.customerId = e.params.data.id;
        $('#create-sale-customer-name').val(e.params.data.text);
      }
      renderSaleCreationErrors();
    });

    // Seleciona a categoria financeira
    $('#create-sale-financial-category').select2({
      placeholder: "Selecione uma categoria financeira",
      theme: 'bootstrap-5',
      dropdownParent: $(".js-create-sale-customer-container"),
      minimumInputLength: 0,
      ajax: {
        url: getBaseDir() + 'api/v1/financial/categories',
        delay: 1000,
        data: function (params) {
          var query = {
            search: params.term,
            branchId: createSaleFormData.current.branch || -1,
            page: params.page || 1,
            type: 'REVENUE'
          }
          // Query parameters will be ?search=[term]&page=[page]
          return query;
        },
        processResults: function (data, params) {
          params.page = params.page || 1;

          var results = [];
          $.each(data.results, function (k, v) {
            results.push({
              id: v.ID,
              text: v.NOME,
              info: v
            });
          });

          // Transforms the top-level key of the response object from 'items' to 'results'
          return {
            results: results,
            pagination: {
              more: (params.page * 10) < data.count_filtered
            }
          };
        }
      }
    });

    // Detecta alteração na seleção da categoria financeira
    $('#create-sale-financial-category').on('select2:select', function (e) {
      if (e.params) {
        createSaleFormData.current.financialCategoryId = e.params.data.id;
      }
    });

    // Limpa a seleção da categoria financeira
    $('.js-create-sale-financial-category-clear-button').on('click', function () {
      $('#create-sale-financial-category').val('').trigger('change');
      createSaleFormData.current.financialCategoryId = null;
    });

    // Seleciona a categoria financeira
    $('#create-sale-financial-cost-center').select2({
      placeholder: "Selecione um centro de custo",
      theme: 'bootstrap-5',
      dropdownParent: $(".js-create-sale-customer-container"),
      minimumInputLength: 0,
      ajax: {
        url: getBaseDir() + 'api/v1/financial/cost-centers',
        delay: 1000,
        data: function (params) {
          var query = {
            search: params.term,
            branchId: createSaleFormData.current.branch || -1,
            page: params.page || 1
          }
          // Query parameters will be ?search=[term]&page=[page]
          return query;
        },
        processResults: function (data, params) {
          params.page = params.page || 1;

          var results = [];
          $.each(data.results, function (k, v) {
            results.push({
              id: v.ID,
              text: `${v.CODIGO} - ${v.NOME}`,
              info: v
            });
          });

          // Transforms the top-level key of the response object from 'items' to 'results'
          return {
            results: results,
            pagination: {
              more: (params.page * 10) < data.count_filtered
            }
          };
        }
      }
    });

    // Detecta alteração na seleção do centro de custo
    $('#create-sale-financial-cost-center').on('select2:select', function (e) {
      if (e.params) {
        createSaleFormData.current.financialCostCenterId = e.params.data.id;
      }
    });

    // Limpa a seleção do centro de custo
    $('.js-create-sale-financial-cost-center-clear-button').on('click', function () {
      $('#create-sale-financial-cost-center').val('').trigger('change');
      createSaleFormData.current.financialCostCenterId = null;
    });

    // Limpa a seleção do cliente
    $('.js-create-sale-customer-clear-button').on('click', function () {
      if (createSaleIsEdit.current) {
        if (createSaleFormData.current.status != 'EM_ABERTO') {
          return window.toast({
            error: true,
            text: 'Não é possível limpar o cliente pois a venda já foi criada.'
          });
        }
      }
      $('#create-sale-customer').val('').trigger('change');
      createSaleCustomerData.current = null;
      createSaleFormData.current.customerId = -1;
      renderSaleCreationErrors();
    });

    // Detecta alteração na data da venda
    $('#create-sale-date').on('change', function () {
      createSaleFormData.current.date = $(this).val();
      renderSaleCreationErrors();
    });

    // Detecta alteração na seleção do tipo de desconto
    $(document).on('change', 'select[name="create-sale-discount-type"]', function () {
      createSaleFormData.current.discountType = $(this).val();
      renderTotalPreview();
      renderSaleCreationErrors();
    });

    // Detecta alteração no valor do desconto
    $(document).on('input', 'input[name="create-sale-discount-value"]', function () {
      createSaleFormData.current.discountValue = moeda2float($(this).val());
      renderTotalPreview();
      renderSaleCreationErrors();
    });

    // Detecta alteração nas observações da venda
    $(document).on('input', 'textarea[name="create-sale-notes"]', function () {
      createSaleFormData.current.notes = $(this).val();
      renderSaleCreationErrors();
    });

    // Detecta alteração na seleção do status da venda
    $(document).on('change', 'select[name="create-sale-status"]', function () {
      createSaleFormData.current.status = $(this).val();
      renderSaleCreationErrors();
    });

    // Detecta clique no botão de criar venda
    $('#form-sale-create').on('submit', function (e) {
      e.preventDefault();
      renderSaleCreationErrors();

      // block all form
      disableForm('#form-sale-create');

      Swal.fire({
        title: createSaleIsEdit.current ? 'Tem certeza que deseja editar a venda?' : 'Tem certeza que deseja criar a venda?',
        text: "Esta ação não pode ser desfeita.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: createSaleIsEdit.current ? 'Sim, editar venda!' : 'Tudo certo, criar venda.',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          apiCall({
            endpoint: createSaleIsEdit.current ? 'api/v1/sale/' + createSaleIsEdit.current : 'api/v1/sale/create',
            method: createSaleIsEdit.current ? 'PUT' : 'POST',
            data: {
              ...createSaleFormData.current
            },
            successCallback: (response) => {
              if (!response.error) {
                Swal.fire({
                  title: 'Venda ' + (createSaleIsEdit.current ? 'editada' : 'criada') + ' com sucesso!',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1500,
                  willClose: () => {
                    $('#modal-sale-create').modal('hide');
                    if (viewSale.current) {
                      OnOpenSaleViewMode();
                    }
                    fetchTableData();
                  }
                });
              } else {
                Swal.fire({
                  title: 'Erro ao criar ' + (createSaleIsEdit.current ? 'venda' : 'venda') + '!',
                  text: response.message,
                  icon: 'error',
                  showConfirmButton: true
                });
              }
              enableForm('#form-sale-create');
              handleBlockSaleCreateFormWhenEdit();
            },
            errorCallback: (err) => {
              Swal.fire({
                title: 'Erro ao criar ' + (createSaleIsEdit.current ? 'venda' : 'venda') + '!',
                text: err.message,
                icon: 'error',
                showConfirmButton: true
              });
              enableForm('#form-sale-create');
              handleBlockSaleCreateFormWhenEdit();
            }
          });
        } else {
          enableForm('#form-sale-create');
          handleBlockSaleCreateFormWhenEdit();
        }
      });
    });

    // Detecta fechamento do modal de criação de venda
    $('#modal-sale-create').on('hidden.bs.modal', function () {
      deleteAllSaleCreateItems();
      deleteAllSaleCreatePaymentMethods();
      handleBlockSaleCreateFormWhenEdit(false);
      createSaleFormData.current = null;
      createSaleCustomerData.current = null;
      createSaleIsEdit.current = false;
      $('#modal-sale-create').removeClass('child-modal');
      $('#form-sale-create').trigger('reset');
      $('#create-sale-branch').prop('disabled', false);
      $('#create-sale-branch').val('').trigger('change');
      $('#create-sale-customer').prop('disabled', true);
      $('#create-sale-customer').val('').trigger('change');
      $('#create-sale-seller').prop('disabled', true);
      $('#create-sale-seller').val('').trigger('change');
      $('#create-sale-date').prop('disabled', true);
      $('#create-sale-date').val('');
      $('#create-sale-financial-category').prop('disabled', true);
      $('#create-sale-financial-category').val('');
      $('#create-sale-financial-cost-center').prop('disabled', true);
      $('#create-sale-financial-cost-center').val('');
      $('#add-create-sale-button').prop('disabled', true);
      $('#create-sale-payment-method').prop('disabled', true);
      $('#create-sale-notes').prop('disabled', false);
      $('#create-sale-notes').val('');
      $('.js-sale-edit-view-area').addClass('d-none');
      $('#create-sale-status').attr('required', false);
      renderSaleCreateItems();
      renderTotalPreview();
      renderPaymentMethodsPreview();
      renderSaleCreatePaymentMethods();
    });

    $('#modal-sale-details').on('hidden.bs.modal', function () {
      viewSale.current = false;
    });
  }

  // Detecta clique no botão para gerar nota fiscal em uma venda
  const handleSaleInvoiceEmission = () => {
    // Detecta clique no botão para gerar nota fiscal em uma venda
    $(document).on('click', '.js-sale-invoice-emission', function (e) {
      e.preventDefault();
      e.stopPropagation();
      let saleInfo = $(this).data('sale-info');
      let selfBtn = this;
      //console.log('saleInfo', saleInfo);

      if (saleInfo.STATUS != 'APROVADO') {
        window.toast({
          error: true,
          text: 'A nota fiscal da venda #' + saleInfo.ID + ' não pode ser emitida pois a venda ainda não foi aprovada.'
        });
        return;
      }

      if (!saleInfo.NOTA_FISCAL_ID) {
        $(selfBtn).prop('disabled', true);
        $('#modal-sale-invoice-create').block(window._loader.loading);
        Swal.fire({
          title: 'Atenção!',
          text: 'A venda #' + saleInfo.ID + ' não possui uma nota fiscal gerada. Deseja gerar uma nota fiscal?',
          icon: 'warning',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, gerar nota fiscal!',
          cancelButtonText: 'Cancelar',
        }).then((result) => {
          if (result.isConfirmed) {
            //console.log('emitir nota fiscal');
            window.toast({
              error: false,
              text: 'Gerando nota fiscal... Por favor, aguarde alguns instantes.',
            });
            apiCall({
              endpoint: 'api/v1/financial/invoice/create',
              method: 'POST',
              data: [
                { name: "financial-sale-id", value: saleInfo.ID }
              ],
              successCallback: (response) => {
                //console.log('response', response);
                $(selfBtn).prop('disabled', false);
                $('#modal-sale-invoice-create').unblock();
                if (response.error) {
                  Swal.fire({
                    title: 'Erro ao emitir nota fiscal!',
                    text: response.message,
                    icon: 'error',
                    showConfirmButton: true
                  });
                } else {
                  Swal.fire({
                    title: 'Nota fiscal gerada com sucesso! Mas ainda não foi emitida. Confira os dados abaixo para emitir a nota fiscal.',
                    icon: 'success',
                    showConfirmButton: true
                  });
                  $('#modal-sale-invoice-create').modal('show');
                  OnMountSaleInvoiceModalData(response.data);
                  fetchTableData();
                }
              },
              errorCallback: (err) => {
                Swal.fire({
                  title: 'Erro ao emitir nota fiscal!',
                  text: err.message,
                  icon: 'error',
                  showConfirmButton: true
                });
                $(selfBtn).prop('disabled', false);
              }
            });
          } else {
            $(selfBtn).prop('disabled', false);
            $('#modal-sale-invoice-create').unblock();
          }
        });
      } else {
        $('#modal-sale-invoice-create').modal('show');
        $(selfBtn).prop('disabled', true);
        window.toast({
          error: false,
          text: 'Carregando nota fiscal... Por favor, aguarde alguns instantes.',
        });
        $('#modal-sale-invoice-create').block(window._loader.loading);
        apiCall({
          endpoint: 'api/v1/financial/invoice/get',
          method: 'GET',
          data: [
            { name: "financial-invoice-id", value: saleInfo.NOTA_FISCAL_ID }
          ],
          successCallback: (response) => {
            $('#modal-sale-invoice-create').unblock();
            //console.log('response', response);
            $(selfBtn).prop('disabled', false);
            if (response.error) {
              window.toast({
                error: true,
                text: 'Erro ao carregar nota fiscal!',
              });
            } else {
              window.toast({
                error: false,
                text: 'Nota fiscal carregada com sucesso!',
              });
              $('#modal-sale-invoice-create').modal('show');
              OnMountSaleInvoiceModalData(response.data);
            }

          },
          errorCallback: (err) => {
            $('#modal-sale-invoice-create').unblock();
            console.error('error', err);
          }
        });
      }
    });

    // Detecta clique no botão para cancelar nota fiscal (não emitida ainda)
    $(document).on('click', '.js-sale-invoice-cancel-button', function (e) {
      e.preventDefault();
      e.stopPropagation();
      let selfBtn = this;
      $(selfBtn).prop('disabled', true);
      Swal.fire({
        title: 'Atenção!',
        text: 'Tem certeza que deseja cancelar a nota fiscal?',
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, cancelar nota fiscal!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          apiCall({
            endpoint: 'api/v1/financial/invoice/cancel',
            method: 'POST',
            data: [
              { name: "financial-invoice-id", value: currentInvoiceData.current.invoiceId }
            ],
            successCallback: (response) => {
              //console.log('response', response);
              $(selfBtn).prop('disabled', false);
              if (response.error) {
                Swal.fire({
                  title: 'Erro ao cancelar nota fiscal!',
                  text: response.message,
                  icon: 'error',
                  showConfirmButton: true
                });
              } else {
                Swal.fire({
                  title: 'Nota fiscal cancelada com sucesso!',
                  icon: 'success',
                  showConfirmButton: true
                });
                $('#modal-sale-invoice-create').modal('hide');
                fetchTableData();
              }
            },
            errorCallback: (err) => {
              console.error('error', err);
              $(selfBtn).prop('disabled', false);
            }
          });
        }
      });
    });

    // Detecta clique no botão para emitir nota fiscal (não emitida ainda)
    $(document).on('click', '.js-sale-invoice-emit-button', function (e) {
      e.preventDefault();
      e.stopPropagation();
      let selfBtn = this;
      $(selfBtn).prop('disabled', true);
      $('.js-sale-invoice-cancel-button').prop('disabled', true);
      if (invoiceEmissionInterval.current) {
        clearInterval(invoiceEmissionInterval.current);
      }

      let payload = [
        { name: "financial-invoice-id", value: currentInvoiceData.current.invoiceId }
      ];

      if (userHasRole('ADMIN') || userHasRole('ADMIN_ASSISTANT')) {
        payload.push({ name: "financial-invoice-client-name", value: $('#sale-invoice-client-name').val() });
        payload.push({ name: "financial-invoice-client-document", value: $('#sale-invoice-client-document').val() });
      }

      Swal.fire({
        title: 'Atenção!',
        text: 'Tem certeza que deseja adicionar a nota fiscal na fila de emissão?',
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, adicionar nota na fila de emissão!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          invoiceEmissionInterval.current = setInterval(() => {
            window.toast({
              error: false,
              text: 'Adicionando nota na fila de emissão... Por favor, aguarde alguns instantes.',
            });
          }, 2500);

          apiCall({
            endpoint: 'api/v1/financial/invoice/emit',
            method: 'POST',
            data: payload,
            successCallback: (response) => {
              clearInterval(invoiceEmissionInterval.current);
              //console.log('response', response);
              if (response.error) {
                $(selfBtn).prop('disabled', false);
                $('.js-sale-invoice-cancel-button').prop('disabled', false);
                Swal.fire({
                  title: 'Ocorreu um erro ao adicionar a nota na fila de emissão!',
                  icon: 'error',
                  html: `Erro: ${response.message}<br>Dados: ${JSON.stringify(response.data)}`
                });
              } else {
                Swal.fire({
                  title: 'Nota fiscal adicionada na fila de emissão! Aguarde a emissão.',
                  icon: 'success'
                });
                $('#modal-sale-invoice-create').modal('hide');
                fetchTableData();
              }
            },
            errorCallback: (err) => {
              clearInterval(invoiceEmissionInterval.current);
              window.toast({
                error: true,
                text: 'Erro interno ao adicionar a nota na fila de emissão!',
              });
              console.error('error', err);
              $(selfBtn).prop('disabled', false);
              $('.js-sale-invoice-cancel-button').prop('disabled', false);
            }
          });
        } else {
          $(selfBtn).prop('disabled', false);
          clearInterval(invoiceEmissionInterval.current);
        }
      });
    });

    // Detecta clique no botão para cancelar nota fiscal (emitida)
    $(document).on('click', '.js-sale-invoice-full-cancel-button', function (e) {
      e.preventDefault();
      e.stopPropagation();
      let selfBtn = this;
      $(selfBtn).prop('disabled', true);
      Swal.fire({
        title: 'Atenção!',
        text: 'Tem certeza que deseja cancelar a nota fiscal?',
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, cancelar nota fiscal!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          apiCall({
            endpoint: 'api/v1/financial/invoice/full-cancel',
            method: 'POST',
            data: [
              { name: "financial-invoice-id", value: currentInvoiceData.current.invoiceId }
            ],
            successCallback: (response) => {
              //console.log('response', response);
              $(selfBtn).prop('disabled', false);
              if (response.error) {
                Swal.fire({
                  title: 'Erro ao cancelar nota fiscal!',
                  text: response.message,
                  icon: 'error',
                  showConfirmButton: true
                });
              } else {
                Swal.fire({
                  title: 'Nota fiscal cancelada com sucesso!',
                  icon: 'success',
                  showConfirmButton: true
                });
                $('#modal-sale-invoice-create').modal('hide');
                fetchTableData();
              }
            },
            errorCallback: (err) => {
              console.error('error', err);
              $(selfBtn).prop('disabled', false);
            }
          });
        } else {
          $(selfBtn).prop('disabled', false);
        }
      });
    });

    // Gera preview da nota fiscal
    $(document).on('click', '.js-sale-invoice-preview-button', function (e) {
      e.preventDefault();
      e.stopPropagation();
      //let selfBtn = this;
      //$(selfBtn).prop('disabled', true);
      window.open('https://thequiro.clinicasajustar.com.br/view-sale-invoice-preview.php?invoice_id=' + currentInvoiceData.current.invoiceId, '_blank');
    });

    // Gera preview da nota fiscal
    $(document).on('click', '.js-sale-invoice-view-pdf-button', function (e) {
      e.preventDefault();
      e.stopPropagation();
      //let selfBtn = this;
      //$(selfBtn).prop('disabled', true);
      window.open('https://thequiro.clinicasajustar.com.br/view-sale-invoice-pdf.php?invoice_id=' + currentInvoiceData.current.invoiceId, '_blank');
    });

    // Gera preview da nota fiscal
    $(document).on('click', '.js-sale-invoice-view-xml-button', function (e) {
      e.preventDefault();
      e.stopPropagation();
      //let selfBtn = this;
      //$(selfBtn).prop('disabled', true);
      window.open('https://thequiro.clinicasajustar.com.br/view-sale-invoice-xml.php?invoice_id=' + currentInvoiceData.current.invoiceId, '_blank');
    });
  }

  // Abre a modal de visualização de uma venda
  const OnOpenSaleViewMode = () => {
    $('.js-view-sale-edit-mode').attr('data-id', viewSale.current);
    $('.js-view-sale-edit-mode').prop('data-id', viewSale.current);
    $('.js-view-sale-edit-mode').data('id', viewSale.current);
    $('#modalSaleViewToggleLabel').html('Detalhes da Venda ' + viewSale.current);
    apiCall({
      endpoint: 'api/v1/sale/' + viewSale.current,
      method: 'GET',
      successCallback: (res) => {
        //console.log('res', res);
        $('#modal-sale-details').unblock();

        if (res.error) {
          Swal.fire({
            title: 'Erro ao carregar informações da venda!',
            text: res.message,
            icon: 'error',
            showConfirmButton: true
          });
          $('#modal-sale-details').modal('hide');
        } else {
          viewSaleData.current = res.data;

          let stoneInfo = Object.values(window._sessionData.allBranches).find((value) => value.ID == res.data.FILIAL_ID).METADATA.integrations?.stone;

          viewSaleData.stoneSaleId = res.data.ID;
          viewSaleData.stoneCurrentOrderId = res.data.STONE_PEDIDO_ID || null;
          viewSaleData.stone = stoneInfo ? true : false;

          const hasInvoiceAuthorized = res.data.NOTA_FISCAL_STATUS == 'AUTORIZADA';

          if (res.data.STATUS == 'CANCELADA_ERRO_LANCAMENTO') {
            window.toast({
              error: true,
              text: 'A venda #' + res.data.ID + ' foi cancelada por erro de lançamento. Não é possível realizar qualquer ação com ela.',
            });
            $('#modal-sale-details').modal('hide');
            return;
          }

          if (hasInvoiceAuthorized) {
            window.toast({
              error: false,
              text: 'A nota fiscal da venda #' + res.data.ID + ' foi autorizada. Não é possível realizar qualquer ação com ela.',
            });
            //$('#modal-sale-details').modal('hide');
            //return;
          }

          $('#view-sale-branch').text(res.data.FILIAL);
          $('#view-sale-customer').text(res.data.CLIENTE_NOME);
          $('#view-sale-date').text(moment(res.data.DATA_VENDA).tz("America/Sao_Paulo").format('DD/MM/YYYY'));
          $('#view-sale-seller').text(res.data.VENDEDOR);
          $('#view-sale-status').html(renderSellStatus(res.data.STATUS));
          $('#view-sale-financial-category').text(res.data.CATEGORIA);
          $('#view-sale-financial-cost-center').text(res.data.CENTRO_DE_CUSTO);

          let html = '',
            itemsTotal = 0;
          for (let i = 0; i < res.data.ITENS.length; i++) {
            let item = res.data.ITENS[i];

            let itemCorrente = item.C_CORRENTE_ID_GERADO !== null ? item.C_CORRENTE_ID_GERADO : null;
            let itemContratoId = item.CONTRATO_ID_GERADO !== null ? item.CONTRATO_ID_GERADO : null;
            let textoCorrente = itemCorrente !== null ? `Conta Corrente: ${itemCorrente}` : `Contrato: ${itemContratoId}`;

            if (itemCorrente == null && itemContratoId == null && res.data.STATUS == 'APROVADO' && item.ID != 29) {
              textoCorrente = `<button class="btn btn-sm btn-secondary js-sale-view-item-corrente" data-bs-toggle="modal" data-bs-target="#modal-sale-item-corrente" data-item-id="${item.ID}">Gerar ${item.TIPO == 0 ? 'conta corrente' : 'contrato'}</button>`;
            } else if (itemCorrente == null && itemContratoId == null && res.data.STATUS == 'EM_ABERTO') {
              textoCorrente = `<span class="text-danger">Informe os recebimentos para gerar a conta corrente ou contrato</span>`;
            } else if (itemCorrente == null && itemContratoId == null && res.data.STATUS == 'CANCELADA_ERRO_LANCAMENTO') {
              textoCorrente = `<span class="text-danger">A venda foi cancelada por erro de lançamento. Não é possível gerar a conta corrente ou contrato</span>`;
            } else if (itemCorrente == null && itemContratoId == null && res.data.STATUS == 'CANCELADA') {
              textoCorrente = `<span class="text-danger">A venda foi cancelada. Não é possível gerar a conta corrente ou contrato</span>`;
            }

            html += `
              <tr>
                <td>${item.NOME}</td>
                <td>Serviço</td>
                <td>${item.DETALHES}</td>
                <td>${item.QUANTIDADE}</td>
                <td>${float2moeda(item.VALOR_UNITARIO)}</td>
                <td>${float2moeda(item.VALOR_TOTAL)}</td>
                <td class="${!hasInvoiceAuthorized && (userHasRole('MANAGER') || userHasRole('COMMERCIAL_ASSISTANT') || userHasRole('ADMIN') || userHasRole('ADMIN_ASSISTANT')) ? '' : 'd-none'}">${textoCorrente}</td>
              </tr>
            `;

            itemsTotal += parseFloat(item.VALOR_TOTAL);
          }
          $('#view-sale-total-preview').text(`R$ ` + float2moeda(itemsTotal));
          $('#view-sale-items-table-body').html(html);

          /*let discountTotal = 0;
          let discountType = res.data.TIPO_DESCONTO;
          if (discountType === 'CASH') {
            discountTotal = VALOR_DESCONTO;
          } else {
            discountTotal = itemsTotal * (res.data.VALOR_DESCONTO / 100);
          }*/

          $('#view-sale-items-total').text(itemsTotal);
          $('#view-sale-discount-preview').text(`R$ ` + float2moeda(res.data.VALOR_DESCONTO));
          $('#view-sale-total-to-pay-preview').text(`R$ ` + float2moeda(res.data.VALOR_TOTAL));

          html = '';
          for (let i = 0; i < res.data.PARCELAS.length; i++) {
            let installment = res.data.PARCELAS[i];
            html += `
              <tr class="${hasInvoiceAuthorized ? '' : 'js-sale-view-installment-row'}" data-installment-id="${installment.ID}">
                <td></td>
                <td>${moment(installment.DATA_VENCIMENTO).tz("America/Sao_Paulo").format('DD/MM/YYYY')}</td>
                <td>${installment.NOME} ${installment.OBS ? `(${installment.OBS}x)` : ''}</td>
                <td>${float2moeda(installment.VALOR_PARCELA)}</td>
                <td>${float2moeda(installment.RECEBIMENTO?.VALOR_RECEBIDO ?? 0)}</td>
                <td>${float2moeda(installment.VALOR_PARCELA - (installment.RECEBIMENTO?.VALOR_RECEBIDO ?? 0))}</td>
                <td>${renderInstallmentStatus(installment.RECEBIMENTO_ID, installment?.RECEBIMENTO_CONCILIADO ?? false)}</td>
                <td>
                  <div class="dropdown ${hasInvoiceAuthorized ? 'd-none' : ''}">
                    <button class="btn btn-sm btn-secondary dropdown-toggle js-sale-view-installment-details" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Ações
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      ${installment.RECEBIMENTO_ID !== null ? `<a class="dropdown-item js-sale-view-acquittance-edit" data-installment-id="${installment.ID}" data-acquittance-id="${installment.RECEBIMENTO_ID}" href="#">Editar recebimento</a>` : `<a class="dropdown-item js-sale-view-acquittance-edit" data-installment-id="${installment.ID}" href="#">Informar recebimento</a>`}
                      <a class="dropdown-item d-none" href="#">Clonar</a>
                      <a class="dropdown-item d-none" href="#">Imprimir</a>
                      <a class="dropdown-item d-none" href="#">Excluir</a>
                    </div>
                  </div>
                </td>
              </tr>
            `;
          }
          $('#view-sale-payment-methods-table-body').html(html);

          html = '';
          for (let i = 0; i < res.data.LOGS.length; i++) {
            let log = res.data.LOGS[i];
            html += `
              <tr>
                <td>${log.ID}</td>
                <td>${log.USUARIO}</td>
                <td>${log.DATA}</td>
                <td>${log.ACAO}</td>
              </tr>
            `;
          }
          $('#view-sale-logs-table-body').html(html);
        }
      },
      errorCallback: (err) => {
        $('#modal-sale-details').unblock();
        console.error('error', err);
      }
    });
  }

  // Abre a modal de edição de uma venda
  const OnOpenSaleEditMode = (event, saleId) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    createSaleIsEdit.current = false;
    let isEditSaleId = saleId;
    //console.log('isEditSaleId', isEditSaleId);
    if (isEditSaleId) {
      $('.js-sale-edit-view-area').removeClass('d-none');
      $('#create-sale-status').attr('required', true);
      createSaleIsEdit.current = isEditSaleId;
      if (!$('#modal-sale-create').is(':visible')) {
        $('#modal-sale-create').modal('show');
      }
      $('#modalSaleCreateToggleLabel').html('Editar Venda');
      $('#modal-sale-create').block(window._loader.loading);
      apiCall({
        endpoint: 'api/v1/sale/' + isEditSaleId,
        method: 'GET',
        successCallback: (response) => {
          //console.log('response', response);
          $('#modal-sale-create').unblock();

          if (response.error) {
            Swal.fire({
              title: 'Erro ao carregar informações da venda!',
              text: response.message,
              icon: 'error',
              showConfirmButton: true
            });
            $('#modal-sale-create').modal('hide');
          } else {
            if (response.data.STATUS == 'CANCELADA_ERRO_LANCAMENTO') {
              window.toast({
                error: true,
                text: 'A venda #' + response.data.ID + ' foi cancelada por erro de lançamento. Não é possível realizar qualquer ação com ela.',
              });
              $('#modal-sale-create').modal('hide');
              return;
            }

            if (response.data.NOTA_FISCAL_STATUS == 'AUTORIZADA') {
              window.toast({
                error: false,
                text: 'A nota fiscal da venda #' + response.data.ID + ' foi autorizada. Não é possível realizar qualquer ação com ela.',
              });
              $('#modal-sale-create').modal('hide');
              return;
            }

            let stoneInfo = Object.values(window._sessionData.allBranches).find((value) => value.ID == response.data.FILIAL_ID).METADATA.integrations?.stone;

            createSaleFormData.current = {
              branch: response.data.FILIAL_ID,
              customerId: response.data.CLIENTE_ID,
              sellerId: response.data.STAFF_ID,
              date: response.data.DATA_VENDA.split(' ')[0],
              items: [],
              itemsTotal: 0,
              discountType: response.data.TIPO_DESCONTO,
              discountValue: parseFloat(response.data.VALOR_DESCONTO),
              paymentMethods: [],
              discountTotal: parseFloat(response.data.VALOR_DESCONTO),
              total: parseFloat(response.data.VALOR_TOTAL),
              notes: response.data.OBSERVACOES,
              status: response.data.STATUS,
              financialCategoryId: response.data.CATEGORIA_ID,
              financialCostCenterId: response.data.CENTRO_CUSTO_ID,
              saleInvoiceStatus: response.data.NOTA_FISCAL_STATUS,
              stoneSaleId: response.data.ID,
              stoneCurrentOrderId: response.data.STONE_PEDIDO_ID || null,
              stone: stoneInfo ? true : false
            }

            for (let i = 0; i < response.data.ITENS.length; i++) {
              createSaleFormData.current.items.push({
                id: response.data.ITENS[i].ID,
                name: response.data.ITENS[i].PRODUTO,
                details: response.data.ITENS[i].DETALHES,
                quantity: response.data.ITENS[i].QUANTIDADE,
                price: parseFloat(response.data.ITENS[i].VALOR_UNITARIO),
                total: parseFloat(response.data.ITENS[i].VALOR_TOTAL),
                info: response.data.ITENS[i]
              })
            }

            createSaleFormData.current.discountType = response.data.TIPO_DESCONTO;
            createSaleFormData.current.discountValue = parseFloat(response.data.VALOR_DESCONTO);

            for (let i = 0; i < response.data.PARCELAS.length; i++) {
              response.data.PARCELAS[i].ID = response.data.PARCELAS[i].FORMA_PAGAMENTO_ID;
              createSaleFormData.current.paymentMethods.push({
                id: response.data.PARCELAS[i].FORMA_PAGAMENTO_ID,
                method: response.data.PARCELAS[i].NOME,
                value: parseFloat(response.data.PARCELAS[i].VALOR_PARCELA),
                condition: response.data.PARCELAS[i].OBS,
                acquirer: response.data.PARCELAS[i].ADQUIRENTE_ID,
                brand: response.data.PARCELAS[i].BANDEIRA_ID,
                financialAccountId: response.data.PARCELAS[i].CONTA_BANCARIA_ID,
                info: response.data.PARCELAS[i]
              })
            }

            createSaleCustomerData.current = {
              id: response.data.CLIENTE_ID,
              name: response.data.CLIENTE_NOME,
              info: response.data
            }

            $('#create-sale-status').val(response.data.STATUS);

            $('#create-sale-branch').val(response.data.FILIAL_ID).trigger('change');
            $('#create-sale-branch').val(response.data.FILIAL_ID).trigger('select2:select');

            $('#create-sale-discount-type').val(response.data.TIPO_DESCONTO).trigger('change');
            $('#create-sale-discount-value').val(float2moeda(response.data.VALOR_DESCONTO));

            if (response.data.CATEGORIA_ID != null) {
              $('#create-sale-financial-category').html(`<option value="${response.data.CATEGORIA_ID}" selected>${response.data.CATEGORIA}</option>`);
              $('#create-sale-financial-category').val(response.data.CATEGORIA_ID).trigger('select2:select');
            }

            if (response.data.CENTRO_CUSTO_ID != null) {
              $('#create-sale-financial-cost-center').html(`<option value="${response.data.CENTRO_CUSTO_ID}" selected>${response.data.CENTRO_CUSTO}</option>`);
              $('#create-sale-financial-cost-center').val(response.data.CENTRO_CUSTO_ID).trigger('select2:select');
            }

            $('#create-sale-financial-category').prop('disabled', false);
            $('#create-sale-financial-cost-center').prop('disabled', false);

            if (userHasRole('ADMIN') || userHasRole('ADMIN_ASSISTANT')) {
              $('#create-sale-date').prop('disabled', false);
            } else {
              $('#create-sale-date').prop('disabled', true);
            }

            renderSaleCreatePaymentMethods();
            renderSaleCreateItems();
            renderSaleCreationErrors();
            renderPaymentMethodsPreview();
            handleBlockSaleCreateFormWhenEdit();
          }
        },
        errorCallback: (err) => {
          $('#modal-sale-create').unblock();
          console.error('error', err);
        }
      });
    } else {
      $('#modal-sale-create').unblock();
      $('#modalSaleCreateToggleLabel').html('Criar Venda');
      createSaleFormData.current = {
        branch: -1,
        customerId: -1,
        sellerId: -1,
        date: null,
        items: [],
        itemsTotal: 0,
        discountType: 'CASH',
        discountValue: 0,
        paymentMethods: [],
        discountTotal: 0,
        total: 0,
        notes: '',
        financialCategoryId: null,
        financialCostCenterId: null,
        saleInvoiceStatus: null,
        stoneSaleId: null,
        stoneCurrentOrderId: null,
        stone: false
      }

      renderSaleCreateItems();
      renderSaleCreationErrors();
    }
  }

  // Abre a modal de visualização de uma parcela
  const OnOpenInstallmentViewMode = (installmentId) => {
    //console.log('OnOpenInstallmentViewMode viewSaleData.current', installmentId, viewSaleData.current);

    let parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == installmentId)?.[0] || {};
    //console.log('OnOpenInstallmentViewMode parcela', parcela);

    $('.js-sale-installment-acquittance').attr('data-installment-id', parcela?.ID);
    $('.js-sale-installment-acquittance').prop('data-installment-id', parcela?.ID);
    $('.js-sale-installment-acquittance').data('installment-id', parcela?.ID);
    $('.js-sale-installment-acquittance').attr('data-acquittance-id', parcela?.RECEBIMENTO_ID);
    $('.js-sale-installment-acquittance').prop('data-acquittance-id', parcela?.RECEBIMENTO_ID);
    $('.js-sale-installment-acquittance').data('acquittance-id', parcela?.RECEBIMENTO_ID);

    $('.js-view-installment-sale-id').html(`Venda #${viewSaleData.current.ID}`);

    $('#view-installment-branch').text($('#view-sale-branch').text());
    $('#view-installment-customer').text($('#view-sale-customer').text());
    $('#view-installment-date').text($('#view-sale-date').text());
    $('#view-installment-due-date').text(moment(parcela.DATA_VENCIMENTO).tz('America/Sao_Paulo').format('DD/MM/YYYY'));

    $('#sale-installment-items-table-body').html(`
      <tr>
        <td>${moment(parcela.DATA_VENCIMENTO).tz('America/Sao_Paulo').format('DD/MM/YYYY')}</td>
        <td>${parcela.NOME}</td>
        <td>${parcela.CONTA_BANCARIA_ID}</td>
        <td>${parcela.VALOR_PARCELA}</td>
        <td>${parcela?.RECEBIMENTO?.VALOR_JUROS ?? 0} / ${parcela?.RECEBIMENTO?.VALOR_MULTA ?? 0}</td>
        <td>${parcela?.RECEBIMENTO?.VALOR_DESCONTO ?? 0} / ${parcela?.RECEBIMENTO?.VALOR_TARIFA ?? 0}</td>
        <td>${renderInstallmentStatus(parcela?.RECEBIMENTO_ID, parcela?.RECEBIMENTO_CONCILIADO ?? false)}</td>
        <td>
          <div class="dropdown">
            <button class="btn btn-sm btn-secondary dropdown-toggle js-sale-view-installment-details" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Ações
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              ${parcela.RECEBIMENTO_ID !== null ? `<a class="dropdown-item js-sale-view-acquittance-edit" data-installment-id="${parcela.ID}" data-acquittance-id="${parcela.RECEBIMENTO_ID}" href="#">Editar recebimento</a>` : `<a class="dropdown-item js-sale-view-acquittance-edit" data-installment-id="${parcela.ID}" href="#">Informar recebimento</a>`}
              <a class="dropdown-item d-none" href="#">Clonar</a>
              <a class="dropdown-item d-none" href="#">Imprimir</a>
              <a class="dropdown-item d-none" href="#">Excluir</a>
            </div>
          </div>
        </td>
      </tr>
    `);

    $('#modal-sale-installment-view').modal('show');
  }

  // Abre a modal de quitação de uma parcela
  const OnOpenAcquittanceViewMode = (installmentId, acquittanceId) => {
    //console.log('OnOpenAcquittanceViewMode', installmentId, acquittanceId);

    currentInstallmentId.current = installmentId;

    let parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == installmentId)?.[0] || {};
    //console.log('OnOpenAcquittanceViewMode parcela', parcela);

    $('input[name="sale-acquittance-installment-value"]').val(float2moeda(parcela.VALOR_PARCELA));
    $('input[name="sale-acquittance-date"]').val(moment(parcela.DATA_VENCIMENTO).tz('America/Sao_Paulo').format('YYYY-MM-DD'));

    $('#sale-acquittance-payment-method').html(`<option value='${parcela.FORMA_PAGAMENTO_ID}' selected>${parcela.NOME}</option>`);
    $('#sale-acquittance-payment-method').val(parcela.FORMA_PAGAMENTO_ID).trigger('select2:select');

    window.reloadMasks();

    if (parcela.RECEBIMENTO_ID !== null || parcela.RECEBIMENTO_CONCILIADO) {
      //alert('a');
      $('#sale-acquittance-amount').val(float2moeda(parcela.RECEBIMENTO.VALOR_RECEBIDO));
      $('#sale-acquittance-fine').val(float2moeda(parcela.RECEBIMENTO.VALOR_MULTA));
      $('#sale-acquittance-interest').val(float2moeda(parcela.RECEBIMENTO.VALOR_JUROS));
      $('#sale-acquittance-discount').val(float2moeda(parcela.RECEBIMENTO.VALOR_DESCONTO));
      $('#sale-acquittance-fee').val(float2moeda(parcela.RECEBIMENTO.VALOR_TARIFA));
      $('#sale-acquittance-condition').val(parcela.OBS);

      $('#modalSaleViewAcquittanceToggleLabel').html('Editar recebimento');
      //$('.js-sale-installment-acquittance-back-to-open').removeClass('d-none');
      //$('#save-create-installment-acquittance').text('Salvar');

      if (parcela?.RECEBIMENTO_ID || parcela?.RECEBIMENTO_CONCILIADO) {
        if (parcela?.RECEBIMENTO_CONCILIADO !== null) {
          $('.js-sale-installment-acquittance-alert-container').removeClass('d-none');
          $('.js-sale-installment-acquittance-alert-container').html(`
            <div class="alert alert-info" role="alert">
              <strong>Atenção!</strong> A parcela #${installmentId} já foi recebida e conciliada.
            </div>
          `);
          $('.js-sale-installment-acquittance-back-to-open').addClass('d-none');
        } else {
          $('.js-sale-installment-acquittance-back-to-open').removeClass('d-none');
        }
        $('#save-create-installment-acquittance').addClass('d-none');
      } else {
        $('.js-sale-installment-acquittance-alert-container').addClass('d-none');
        $('.js-sale-installment-acquittance-back-to-open').removeClass('d-none');
        $('#save-create-installment-acquittance').removeClass('d-none');
        $('#save-create-installment-acquittance').text('Salvar');
      }

      //disableForm('.js-sale-installment-acquittance-modal-body');
    } else {
      //alert('b');
      $('#sale-acquittance-amount').val('');
      $('#sale-acquittance-fine').val('');
      $('#sale-acquittance-interest').val('');
      $('#sale-acquittance-discount').val('');
      $('#sale-acquittance-fee').val('');
      //$('#sale-acquittance-condition').val('');

      $('.js-sale-installment-acquittance-alert-container').html(``);
      $('.js-sale-installment-acquittance-alert-container').addClass('d-none');
      $('#modalSaleViewAcquittanceToggleLabel').html('Informar recebimento');
      $('.js-sale-installment-acquittance-back-to-open').addClass('d-none');
      $('#save-create-installment-acquittance').text('Confirmar recebimento');
      $('#save-create-installment-acquittance').removeClass('d-none');

      //enableForm('.js-sale-installment-acquittance-modal-body');
    }

    $('#modal-sale-installment-acquittance-edit').modal('show');
  }

  // Monta modal de emissão de nota fiscal
  const OnMountSaleInvoiceModalData = (data) => {
    //console.log('OnMountSaleInvoiceModalData', data);

    currentInvoiceData.current = data;

    let description = '';
    data.saleItems.forEach(item => {
      //console.log('item', item);
      description += `${item.QUANTIDADE}x ${item.PRODUTO} ${item.DETALHES} ${float2moeda(item.VALOR_TOTAL)}\n`;
    });

    //console.log('description', description);

    let branchData = data.branchData;
    let customerData = data.customerData;

    $('#sale-invoice-client-name').val(customerData.NOME_COMPLETO);
    $('#sale-invoice-client-document').val(customerData.CPF);
    $('#sale-invoice-client-phone').val(customerData.FONE_CELULAR);
    $('#sale-invoice-client-email').val(customerData.EMAIL);
    $('#sale-invoice-client-cep').val(customerData.CEP);
    $('#sale-invoice-client-address').val(customerData.RUA);
    $('#sale-invoice-client-address-number').val(customerData.NUMERO);
    $('#sale-invoice-client-address-complement').val(customerData.COMPLEMENTO);
    $('#sale-invoice-client-address-neighborhood').val(customerData.BAIRRO);
    $('#sale-invoice-client-address-city').val(customerData.CIDADE);
    $('#sale-invoice-client-address-state').val(customerData.ESTADO);

    $('#sale-invoice-company-name').val(branchData.RAZAO_SOCIAL)
    $('#sale-invoice-company-document').val(branchData.CNPJ)
    $('#sale-invoice-company-address').val(`${branchData.RUA}, ${branchData.NUMERO} ${branchData.COMPLEMENTO} - ${branchData.BAIRRO} - ${branchData.CIDADE} - ${branchData.ESTADO}`)

    $('#sale-invoice-issue-date').val(moment(data.invoiceDate).tz('America/Sao_Paulo').format('DD/MM/YYYY'));
    $('#sale-invoice-city').val(branchData.CIDADE);
    $('#sale-invoice-state').val(branchData.ESTADO);
    $('#sale-invoice-service-description').val(description);
    $('#sale-invoice-service-code').val(branchData.CNAE);

    $('#sale-invoice-taxes-table').html(`
      <tr>
        <td>ISS</td>
        <td>${branchData.ALIQUOTA_ISS}%</td>
      </tr>
    `);

    $('#sale-invoice-services-total').val(float2moeda(data.saleData.VALOR_TOTAL));
    $('#sale-invoice-taxes-total').val(float2moeda(data.saleData.VALOR_TOTAL * (branchData.ALIQUOTA_ISS / 100)));
    $('#sale-invoice-total').val(float2moeda(data.saleData.VALOR_TOTAL)); //  + (data.saleData.VALOR_TOTAL * (branchData.ALIQUOTA_ISS / 100))

    if (data.invoiceStatus != 'PENDENTE') {
      //
      if (data.invoiceStatus == 'AUTORIZADA') {
        $('.js-sale-invoice-emit-button').prop('disabled', true);
        $('.js-sale-invoice-cancel-button').prop('disabled', true);
        $('.js-sale-invoice-view-pdf-button').removeClass('d-none');
        $('.js-sale-invoice-view-xml-button').removeClass('d-none');
        $('.js-sale-invoice-full-cancel-button').removeClass('d-none');
      } else {
        $('.js-sale-invoice-cancel-button').prop('disabled', false);
        $('.js-sale-invoice-view-pdf-button').addClass('d-none');
        $('.js-sale-invoice-view-xml-button').addClass('d-none');
        $('.js-sale-invoice-full-cancel-button').addClass('d-none');
      }
    } else {
      $('.js-sale-invoice-emit-button').prop('disabled', false);
      $('.js-sale-invoice-cancel-button').prop('disabled', false);
      $('.js-sale-invoice-view-pdf-button').addClass('d-none');
      $('.js-sale-invoice-view-xml-button').addClass('d-none');
      $('.js-sale-invoice-full-cancel-button').addClass('d-none');
    }

    if (data.invoiceStatus == 'AUTORIZADA') {
      $(`.js-invoice-status-container`).html(`
        <div class="alert alert-success" role="alert">
          <strong>Atenção!</strong> A nota fiscal da venda #${data.saleData.ID} foi emitida com sucesso!
        </div>
      `);
    } else if (data.invoiceStatus == 'CANCELADO') {
      $(`.js-invoice-status-container`).html(`
        <div class="alert alert-danger" role="alert">
          <strong>Atenção!</strong> A nota fiscal da venda #${data.saleData.ID} foi cancelada. Não é possível realizar qualquer ação com ela.
        </div>
      `);
    } else if (data.invoiceStatus == 'EM_PROCESSAMENTO') {
      $(`.js-invoice-status-container`).html(`
        <div class="alert alert-warning" role="alert">
          <strong>Atenção!</strong> A nota fiscal da venda #${data.saleData.ID} está em processamento. Aguarde o processamento por parte do sistema.
        </div>
      `);
    } else if (data.invoiceStatus == 'ERRO') {
      let errorMessage = `A nota fiscal da venda #${data.saleData.ID} apresentou erro. Aguarde a correção do erro para que seja emitida.`;

      if (data.lastWebhookInfo) {
        try {
          const webhookData = JSON.parse(data.lastWebhookInfo.DATA);
          errorMessage += `<br><br><strong>Detalhes do erro:</strong><br>`;
          errorMessage += `Código: ${webhookData.codigo}<br>`;
          errorMessage += `Mensagem: ${webhookData.mensagem}`;
        } catch (e) {
          console.error('Erro ao processar lastWebhookInfo:', e);
        }
      }

      $(`.js-invoice-status-container`).html(`
        <div class="alert alert-danger" role="alert">
          <strong>Atenção!</strong> ${errorMessage}
        </div>
      `);
    } else if ((data.invoiceStatus == 'PENDENTE') && !data.invoiceQueueInfo) {
      //$('.js-sale-invoice-cancel-button').prop('disabled', true);
      $(`.js-invoice-status-container`).html(`
        <div class="alert alert-warning" role="alert">
          <strong>Atenção!</strong> A nota fiscal da venda #${data.saleData.ID} <b>está gerada</b> porém <b>não está na fila de emissão</b>. Você deve adicionar a nota na fila de emissão para que seja emitida.
        </div>
      `);
    } else if ((data.invoiceStatus == 'PENDENTE' || data.invoiceStatus == 'EM_PROCESSAMENTO') && data.invoiceQueueInfo) {
      if (data.invoiceQueueInfo.STATUS == 'AGUARDANDO_FILA') {
        $('.js-sale-invoice-cancel-button').prop('disabled', false);
      } else if (data.invoiceQueueInfo.STATUS == 'EMITINDO') {
        $('.js-sale-invoice-cancel-button').prop('disabled', true);
      } else if (data.invoiceQueueInfo.STATUS == 'EMITIDA') {
        $('.js-sale-invoice-cancel-button').prop('disabled', true);
      } else if (data.invoiceQueueInfo.STATUS == 'ERRO') {
        $('.js-sale-invoice-cancel-button').prop('disabled', false);
      }
      //$('.js-sale-invoice-cancel-button').prop('disabled', true);
      $('.js-sale-invoice-emit-button').prop('disabled', true);
      $(`.js-invoice-status-container`).html(`
        <div class="alert alert-warning" role="alert">
          <strong>Atenção!</strong> A nota fiscal da venda #${data.saleData.ID} <b>está gerada</b> e <b>na fila de emissão</b>. Aguarde a emissão.<div class="divider mt-2"></div>
          Status na fila: ${data.invoiceQueueInfo.STATUS}<br />
          Data de adição na fila: ${moment(data.invoiceQueueInfo.CRIADO_EM).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')}<br />
          Data de atualização na fila: ${moment(data.invoiceQueueInfo.ATUALIZADO_EM).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')}
        </div>
      `);
    } else if (data.invoiceStatus == 'REJEITADA') {
      $('.js-sale-invoice-emit-button').prop('disabled', true);

      let errorMessage = `A nota fiscal da venda #${data.saleData.ID} foi rejeitada por algum motivo. Você pode cancelar a nota fiscal, gerar uma nova nota fiscal e adicionar a nota na fila de emissão novamente.`;

      if (data.lastWebhookInfo) {
        try {
          const webhookData = JSON.parse(data.lastWebhookInfo.DATA);
          errorMessage += `<br><br><strong>Detalhes da rejeição:</strong><br>`;
          errorMessage += `Código: ${webhookData.codigo}<br>`;
          errorMessage += `Mensagem: ${webhookData.mensagem}`;

          if (data.invoiceQueueInfo) {
            errorMessage += `<br><br><strong>Detalhes da fila de emissão:</strong><br>`;
            errorMessage += `Status: ${data.invoiceQueueInfo.STATUS}<br>`;
            errorMessage += `Data de criação: ${moment(data.invoiceQueueInfo.CRIADO_EM).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')}<br>`;
            errorMessage += `Data de atualização: ${moment(data.invoiceQueueInfo.ATUALIZADO_EM).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')}<br><br>`;
            errorMessage += `Para continuar o processamento de notas fiscais dessa unidade, você deve cancelar essa nota fiscal!`;
          }
        } catch (e) {
          console.error('Erro ao processar lastWebhookInfo:', e);
        }
      }

      $(`.js-invoice-status-container`).html(`
        <div class="alert alert-danger" role="alert">
          <strong>Atenção!</strong> ${errorMessage}
        </div>
      `);
    }
  }

  // Monta modal de cancelamento de uma venda
  const OnOpenSaleCancelMode = (saleId) => {
    Swal.fire({
      title: 'Tem certeza que deseja cancelar a venda?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, cancelar',
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#3085d6',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      showLoaderOnConfirm: true,
      showLoaderOnConfirm: true,
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        apiCall({
          endpoint: 'api/v1/sale/cancel',
          method: 'POST',
          data: {
            saleId: saleId
          },
          successCallback: (response) => {
            //console.log('response', response);
            window.toast({
              error: response.error,
              text: response.message
            });
            if (!response.error) {
              fetchTableData();
            }
          },
          errorCallback: (err) => {
            console.error('error', err);
          }
        });
      }
    });
  }

  // Detecta alterações no formulário de quitação de uma parcela
  const handleSaleInstallmentAcquittance = () => {
    $('#sale-acquittance-payment-method').select2({
      placeholder: "Selecione o método",
      theme: 'bootstrap-5',
      dropdownParent: $(`.js-sale-acquittance-payment-method-container`),
      minimumInputLength: 0,
      ajax: {
        url: getBaseDir() + 'api/v1/sale/payment-methods',
        delay: 1000,
        data: function (params) {
          var query = {
            search: params.term,
            page: params.page || 1
          }
          return query;
        },
        processResults: function (data, params) {
          params.page = params.page || 1;

          var results = [];
          $.each(data.data, function (k, v) {
            results.push({
              id: v.ID,
              text: v.NOME,
              info: v
            });
          });

          return {
            results: results,
            pagination: {
              more: (params.page * 10) < data.count_filtered
            }
          };
        }
      }
    });

    $('#sale-acquittance-payment-method').on('select2:select', function (e) {
      let parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)?.[0] || {};
      //console.log('parcela', parcela);
      let hadNoParams = !e.params;
      if (!e.params) {
        e.params = {
          data: {
            id: parcela.FORMA_PAGAMENTO_ID,
            info: parcela
          }
        }
      } else {
        parcela.FORMA_PAGAMENTO_ID = e.params.data.info.ID;
        viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)[0] = parcela;
      }

      if (e.params.data.info.MAX_PARCELAS != null) {
        let html = `<option value="" disabled>Selecione a condição</option>`;
        for (let j = 1; j <= e.params.data.info.MAX_PARCELAS; j++) {
          html += `<option value="${j}" ${parcela.OBS == j ? 'selected' : ''}>${j}x</option>`;
        }
        $(`#sale-acquittance-condition`).html(html);

        apiCall({
          endpoint: 'api/v1/sale/payment-methods/acquirers',
          method: 'GET',
          data: {
            paymentMethodId: hadNoParams ? parcela.FORMA_PAGAMENTO_ID : e.params.data.info.ID,
            acquirerIds: e.params.data.info.ADQUIRENTES_IDS
          },
          successCallback: (response) => {
            currentAcquirerersData.current = response.data;
            let html = `<option value="" selected disabled>Selecione o adquirente</option>`;
            $.each(response.data, function (k, v) {
              html += `<option value="${v.ID}" data-info='${JSON.stringify(v)}' ${parcela.ADQUIRENTE_ID == v.ID ? 'selected' : ''}>${v.NOME}</option>`;
            });
            $(`#sale-acquittance-acquirer`).html(html);


            if (parcela.ADQUIRENTE_ID != null && parcela.BANDEIRA_ID != null) {
              let adquirenteData = currentAcquirerersData.current.find(item => item.ID == parcela.ADQUIRENTE_ID);
              if (adquirenteData.BANDEIRAS.length > 0) {
                let html = `<option value="" selected disabled>Selecione a bandeira</option>`;
                $.each(adquirenteData.BANDEIRAS, function (k, v) {
                  html += `<option value="${v.ID}" ${parcela.BANDEIRA_ID == v.ID ? 'selected' : ''}>${v.BANDEIRA}</option>`;
                });
                $(`#sale-acquittance-bandeira`).html(html);
              } else {
                $(`#sale-acquittance-bandeira`).html('<option value="" selected disabled>Sem bandeira</option>');
              }
            }
          },
          errorCallback: (err) => {
            console.error('error', err);
          }
        });
      } else {
        currentAcquirerersData.current = [];
        viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)[0].ADQUIRENTE_ID = null;
        viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)[0].BANDEIRA_ID = null;
        viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)[0].OBS = 1;
        $(`#sale-acquittance-acquirer`).html('<option value="" selected disabled>Sem adquirente</option>');
        $(`#sale-acquittance-bandeira`).html('<option value="" selected disabled>Sem bandeira</option>');
        $(`#sale-acquittance-condition`).html(`
          <option value="1" selected disabled>À vista</option>
        `);
      }

      if (e.params.data.info.CONTAS_BANCARIAS != null) {
        if (e.params.data.info.CONTAS_BANCARIAS.length > 0) {
          let html = `<option value="" selected disabled>Selecione a conta bancária</option>`;
          $.each(e.params.data.info.CONTAS_BANCARIAS, function (k, v) {
            html += `<option value="${v.ID}" ${parcela.CONTA_BANCARIA_ID == v.ID ? 'selected' : ''} data-is-bank="1">${v.CONTA}</option>`;
          });
          setTimeout(() => {
            $(`#sale-acquittance-acquirer`).html(html);
          }, 1000);
        }
      }
    });

    $(document).on('change', '#sale-acquittance-acquirer', function () {
      let parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)?.[0] || {};
      let isBank = $(this).find('option:selected').data('is-bank');
      if (isBank == 1) {
        parcela.CONTA_BANCARIA_ID = $(this).val();
      } else {
        parcela.ADQUIRENTE_ID = $(this).val();
      }
      viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)[0] = parcela;

      if (parcela.ADQUIRENTE_ID != null) {
        let adquirenteData = currentAcquirerersData.current.find(item => item.ID == parcela.ADQUIRENTE_ID);
        if (adquirenteData?.BANDEIRAS?.length > 0) {
          let html = `<option value="" selected disabled>Selecione a bandeira</option>`;
          $.each(adquirenteData.BANDEIRAS, function (k, v) {
            html += `<option value="${v.ID}" ${parcela.BANDEIRA_ID == v.ID ? 'selected' : ''}>${v.BANDEIRA}</option>`;
          });
          $(`#sale-acquittance-bandeira`).html(html);
        } else {
          $(`#sale-acquittance-bandeira`).html('<option value="" selected disabled>Sem bandeira</option>');
        }
      }
    });

    $(document).on('change', '#sale-acquittance-bandeira', function () {
      let parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)?.[0] || {};
      parcela.BANDEIRA_ID = $(this).val();
      viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)[0] = parcela;
    });

    $(document).on('change', '#sale-acquittance-condition', function () {
      let parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)?.[0] || {};
      parcela.OBS = $(this).val();
      viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)[0] = parcela;
    });

    $(document).on('click', '#save-create-installment-acquittance', function () {
      var parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)?.[0] || {};
      let
        valorParcela = moeda2float($('#sale-acquittance-installment-value').val()),
        valorRecebido = moeda2float($('#sale-acquittance-amount').val()),
        valorMulta = moeda2float($('#sale-acquittance-fine').val()),
        valorJuros = moeda2float($('#sale-acquittance-interest').val()),
        valorDesconto = moeda2float($('#sale-acquittance-discount').val()),
        valorTarifa = moeda2float($('#sale-acquittance-fee').val());

      if (isNaN(valorRecebido))
        valorRecebido = 0;
      if (isNaN(valorMulta))
        valorMulta = 0;
      if (isNaN(valorJuros))
        valorJuros = 0;
      if (isNaN(valorDesconto))
        valorDesconto = 0;
      if (isNaN(valorTarifa))
        valorTarifa = 0;

      if (valorRecebido > valorParcela)
        return window.toast({
          error: true,
          text: `O valor informado como recebido (${float2moeda(valorRecebido)}) é maior que o valor da parcela (${float2moeda(valorParcela)})`
        });

      disableForm('.js-sale-installment-acquittance-modal-container');

      Swal.fire({
        title: 'Tem certeza que deseja salvar?',
        text: 'Você está prestes a salvar a quitação da parcela ' + parcela.NOME + ' da venda ' + viewSaleData.current.ID,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, salvar',
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33'
      }).then((result) => {
        if (result.isConfirmed) {
          let parcelaData = {
            ID: parcela.ID,
            FORMA_PAGAMENTO_ID: parcela.FORMA_PAGAMENTO_ID,
            ADQUIRENTE_ID: parcela.ADQUIRENTE_ID,
            BANDEIRA_ID: parcela.BANDEIRA_ID,
            OBS: parcela.OBS,
            CONTA_BANCARIA_ID: parcela.CONTA_BANCARIA_ID,
            RECEBIMENTO: {
              ...(parcela.RECEBIMENTO_ID != null ? {
                ID: parcela.RECEBIMENTO_ID
              } : {}),
              DATA_RECEBIMENTO: $('#sale-acquittance-date').val(),
              VALOR_RECEBIDO: moeda2float($('#sale-acquittance-amount').val()),
              VALOR_MULTA: moeda2float($('#sale-acquittance-fine').val()),
              VALOR_JUROS: moeda2float($('#sale-acquittance-interest').val()),
              VALOR_DESCONTO: moeda2float($('#sale-acquittance-discount').val()),
              VALOR_TARIFA: moeda2float($('#sale-acquittance-fee').val())
            }
          }

          apiCall({
            endpoint: 'api/v1/sale/installments/acquittances',
            method: 'POST',
            data: parcelaData,
            successCallback: (response) => {
              //console.log('res', response);
              window.toast({
                success: response.error,
                text: response.message
              });

              if (!response.error) {
                currentInstallmentId.current = null;
                $('#modal-sale-installment-view').modal('hide');
                $('#modal-sale-installment-acquittance-edit').modal('hide');
                OnOpenSaleViewMode();
                fetchTableData();
              }

              enableForm('.js-sale-installment-acquittance-modal-container');
            },
            errorCallback: (err) => {
              enableForm('.js-sale-installment-acquittance-modal-container');
              console.error('error', err);
            }
          });
        } else {
          enableForm('.js-sale-installment-acquittance-modal-container');
        }
      });
    });

    $(document).on('click', '.js-sale-installment-acquittance-back-to-open', function () {
      var parcela = viewSaleData.current.PARCELAS.filter((obj) => obj.ID == currentInstallmentId.current)?.[0] || {};
      disableForm('.js-sale-installment-acquittance-modal-container');
      Swal.fire({
        title: 'Tem certeza que deseja voltar para Em Aberto?',
        text: 'Você está prestes a voltar a parcela para Em Aberto',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, voltar',
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33'
      }).then((result) => {
        if (result.isConfirmed) {
          apiCall({
            endpoint: 'api/v1/sale/installments/acquittances',
            method: 'DELETE',
            data: {
              ID: parcela.RECEBIMENTO.ID
            },
            successCallback: (response) => {
              window.toast({
                success: response.error,
                text: response.message
              });

              if (!response.error) {
                currentInstallmentId.current = null;
                $('#modal-sale-installment-view').modal('hide');
                $('#modal-sale-installment-acquittance-edit').modal('hide');
                OnOpenSaleViewMode();
                fetchTableData();
              }

              enableForm('.js-sale-installment-acquittance-modal-container');
            },
            errorCallback: (err) => {
              enableForm('.js-sale-installment-acquittance-modal-container');
              console.error('error', err);
            }
          });
        } else {
          enableForm('.js-sale-installment-acquittance-modal-container');
        }
      });
    });
  }

  // Bloqueia o formulário de criação de venda quando está em modo de edição
  const handleBlockSaleCreateFormWhenEdit = (lock = true) => {
    if (createSaleIsEdit.current) {
      $('#create-sale-branch').prop('disabled', lock);
      //console.log('createSaleFormData.current.status', createSaleFormData.current.status);
      //console.log('createSaleFormData.current.saleInvoiceStatus', createSaleFormData.current.saleInvoiceStatus);
      if (createSaleFormData?.current?.status != 'EM_ABERTO') {
        $('#create-sale-customer').prop('disabled', lock);
        if (createSaleFormData.current.saleInvoiceStatus == 'AUTORIZADA') {
          $('#create-sale-seller').prop('disabled', false);
          $('#create-sale-status').attr('required', false);
        } else {
          $('#create-sale-seller').prop('disabled', lock);
        }
        $('#create-sale-date').prop('disabled', lock);
      } else {
        if (userHasRole('ADMIN') || userHasRole('ADMIN_ASSISTANT')) {
          $('#create-sale-seller').prop('disabled', false);
        }
      }

      $('#add-create-sale-button').prop('disabled', lock);
      if (createSaleFormData?.current?.status != 'EM_ABERTO') {
        $('#create-sale-payment-method').prop('disabled', lock);
        $('#create-sale-notes').prop('disabled', lock);
      }

      // block items inpunts
      if (createSaleFormData.current !== null) {
        for (let i = 0; i < createSaleFormData.current.items.length; i++) {
          if (createSaleFormData?.current?.status != 'EM_ABERTO') {
            $(`.js-create-sale-item-name-${i}`).prop('disabled', lock);
            $(`.js-create-sale-item-details-${i}`).prop('disabled', lock);
            $(`.js-create-sale-item-quantity-${i}`).prop('disabled', lock);
            $(`.js-create-sale-item-price-${i}`).prop('disabled', lock);
            $(`.js-create-sale-item-total-${i}`).prop('disabled', lock);
          }
        }
      }

      // block payment methods inputs
      if (createSaleFormData.current !== null) {
        for (let i = 0; i < createSaleFormData.current.paymentMethods.length; i++) {
          let isBlockedForEdit = false;
          if (createSaleFormData.current.paymentMethods[i]?.info?.RECEBIMENTO_ID != null) {
            isBlockedForEdit = true;
          }

          if (createSaleFormData?.current?.status != 'EM_ABERTO') {
            $(`.js-create-sale-item-method-${i}`).prop('disabled', lock);
            $(`.js-create-sale-item-value-${i}`).prop('disabled', lock);
            $(`.js-create-sale-item-acquirer-${i}`).prop('disabled', lock);
            $(`.js-create-sale-item-condition-${i}`).prop('disabled', lock);
            $(`.js-create-sale-item-brand-${i}`).prop('disabled', lock);
            $(`.js-create-sale-item-financial-account-${i}`).prop('disabled', lock);
          } else {
            if (isBlockedForEdit) {
              $(`.js-create-sale-item-method-${i}`).prop('disabled', lock);
              $(`.js-create-sale-item-value-${i}`).prop('disabled', lock);
              $(`.js-create-sale-item-acquirer-${i}`).prop('disabled', lock);
              $(`.js-create-sale-item-condition-${i}`).prop('disabled', lock);
              $(`.js-create-sale-item-brand-${i}`).prop('disabled', lock);
              $(`.js-create-sale-item-financial-account-${i}`).prop('disabled', lock);
            }
          }
        }
      }

      if (createSaleFormData?.current?.status != 'EM_ABERTO') {
        // block add item button
        $('.js-create-sale-add-sale-item').prop('disabled', lock);

        // block add payment method button
        $('.js-create-sale-add-payment-method').prop('disabled', lock);

        // block discount input 
        $('#create-sale-discount-type').prop('disabled', lock);
        $('#create-sale-discount-value').prop('disabled', lock);
      }
    }
  }

  // Detecta clique no botão de adicionar item e remove item
  const handleSaleCreateAddItem = () => {
    // Detecta clique no botão de adicionar item
    $(document).on('click', '.js-create-sale-add-sale-item', function () {
      /*if (createSaleFormData.current.items.length == 1) {
        return window.toast({
          error: true,
          text: 'Não é possível adicionar mais de um item à venda.'
        });
      }*/
      createSaleFormData.current.items.push({
        id: -1,
        name: '',
        details: '',
        quantity: 1,
        price: 0,
        total: 0
      });
      renderSaleCreateItems(true);
      renderSaleCreationErrors();
    });

    // Detecta clique no botão de remover item
    $(document).on('click', '.js-create-sale-remove-item', function () {
      if (createSaleIsEdit.current) {
        if (createSaleFormData.current.status != 'EM_ABERTO') {
          return window.toast({
            error: true,
            text: 'Não é possível remover o item pois a venda já foi criada.'
          });
        }
      }
      const index = $(this).data('index');
      if (index >= 0) {
        $(`.js-create-sale-item-name-${index}`).select2('destroy');
        $(document).off('input', `.js-create-sale-item-details-${index}`);
        $(document).off('input', `.js-create-sale-item-quantity-${index}`);
        $(document).off('input', `.js-create-sale-item-price-${index}`);
        $(document).off('input', `.js-create-sale-item-total-${index}`);
        createSaleFormData.current.items.splice(index, 1);
        renderSaleCreateItems();
        renderSaleCreationErrors();
      }
    });
  }

  // Configura os inputs dos itens
  const handleSaleCreateItemInputs = () => {
    // Configura os inputs dos itens
    if (createSaleFormData.current !== null) {
      for (let i = 0; i < createSaleFormData.current.items.length; i++) {
        // Seleciona o item
        $(`.js-create-sale-item-name-${i}`).select2({
          placeholder: "Selecione o item",
          theme: 'bootstrap-5',
          dropdownParent: $(`.js-create-sale-item-name-${i}-container`),
          minimumInputLength: 0,
          ajax: {
            url: getBaseDir() + 'api/v1/sale/products',
            delay: 1000,
            data: function (params) {
              var query = {
                search: params.term,
                //branchId: createSaleFormData.current.branch || -1,
                page: params.page || 1
              }
              return query;
            },
            processResults: function (data, params) {
              params.page = params.page || 1;

              var results = [];
              $.each(data.results, function (k, v) {
                //if (v.CONTRATOS != null) {
                results.push({
                  id: v.ID,
                  text: `${v.NOME}`,
                  info: v
                });
                //}
              });

              // Transforms the top-level key of the response object from 'items' to 'results'
              return {
                results: results,
                pagination: {
                  more: (params.page * 10) < data.count_filtered
                }
              };
            }
          }
        });

        // if product is already in the sale, then select the product
        if (createSaleFormData.current.items[i].id != -1) {
          setTimeout(() => {
            $(`.js-create-sale-item-name-${i}`).html(`<option value="${createSaleFormData.current.items[i].id}" selected>${createSaleFormData.current.items[i].name}</option>`);
            $(`.js-create-sale-item-name-${i}`).val(createSaleFormData.current.items[i].id).trigger('select2:select');
          }, 290);
        }

        // Detecta alteração na seleção do item
        $(`.js-create-sale-item-name-${i}`).on('select2:select', function (e) {
          if (!e.params) {
            if (!e.params) {
              e.params = {
                data: {}
              }
            }
            e.params.data = {
              ID: createSaleFormData.current.items[i].id,
              info: createSaleFormData.current.items[i].info
            }
          }
          //console.log('e.params.data', e.params.data);
          createSaleFormData.current.items[i].id = e.params.data.info.ID;
          createSaleFormData.current.items[i].name = e.params.data.info.NOME;
          createSaleFormData.current.items[i].quantity = 1;
          createSaleFormData.current.items[i].price = parseFloat(e.params.data.info.VALOR);
          createSaleFormData.current.items[i].total = parseFloat(e.params.data.info.VALOR);

          $(`.js-create-sale-item-quantity-${i}`).val(1);
          $(`.js-create-sale-item-price-${i}`).val(float2moeda(parseFloat(createSaleFormData.current.items[i].price).toFixed(2)));
          $(`.js-create-sale-item-total-${i}`).val(float2moeda(parseFloat(createSaleFormData.current.items[i].total).toFixed(2)));

          renderTotalPreview();
        });

        // Detecta alteração no campo de detalhes do item
        $(document).on('input', `.js-create-sale-item-details-${i}`, function () {
          createSaleFormData.current.items[i].details = $(this).val();
          $(`.jjs-create-sale-item-details-${i}`).val(createSaleFormData.current.items[i].details);
        });

        // Detecta alteração na quantidade do item
        $(document).on('input', `.js-create-sale-item-quantity-${i}`, function () {
          createSaleFormData.current.items[i].quantity = parseInt($(this).val());
          createSaleFormData.current.items[i].total = createSaleFormData.current.items[i].price * createSaleFormData.current.items[i].quantity;
          $(`.js-create-sale-item-quantity-${i}`).val(createSaleFormData.current.items[i].quantity);
          $(`.js-create-sale-item-total-${i}`).val(createSaleFormData.current.items[i].total);

          renderTotalPreview();
        });

        // Detecta alteração no preço do item
        $(document).on('input', `.js-create-sale-item-price-${i}`, function () {
          createSaleFormData.current.items[i].price = moeda2float($(this).val());
          createSaleFormData.current.items[i].total = createSaleFormData.current.items[i].price * createSaleFormData.current.items[i].quantity;
          //$(`.js-create-sale-item-price-${i}`).val(createSaleFormData.current.items[i].price);
          $(`.js-create-sale-item-total-${i}`).val(createSaleFormData.current.items[i].total);

          renderTotalPreview();
        });

        // Detecta alteração no total do item
        $(document).on('input', `.js-create-sale-item-total-${i}`, function () {
          createSaleFormData.current.items[i].price = moeda2float($(this).val()) / createSaleFormData.current.items[i].quantity;
          createSaleFormData.current.items[i].total = moeda2float($(this).val());

          $(`.js-create-sale-item-price-${i}`).val(createSaleFormData.current.items[i].price);
          $(`.js-create-sale-item-total-${i}`).val(createSaleFormData.current.items[i].total);

          renderTotalPreview();
        });

        // Detecta clique no botão de limpar o item
        $(`.js-create-sale-item-name-clear-button-${i}`).on('click', function () {
          if (createSaleIsEdit.current) {
            if (createSaleFormData.current.status != 'EM_ABERTO') {
              return window.toast({
                error: true,
                text: 'Não é possível limpar o item pois a venda já foi criada.'
              });
            }
          }
          $(`.js-create-sale-item-name-${i}`).val('').trigger('change');
          createSaleFormData.current.items[i].id = -1;
          createSaleFormData.current.items[i].name = '';
          $(`.js-create-sale-item-details-${i}`).val('');
          $(`.js-create-sale-item-quantity-${i}`).val(1);
          $(`.js-create-sale-item-price-${i}`).val(0);
          $(`.js-create-sale-item-total-${i}`).val(0);

          renderTotalPreview();
        });
      }
    }
  }

  // Limpa todos os itens da venda
  const deleteAllSaleCreateItems = () => {
    for (let i = 0; i < createSaleFormData.current.items.length; i++) {
      $(`.js-create-sale-item-name-${i}`).select2('destroy');
      $(document).off('input', `.js-create-sale-item-details-${i}`);
      $(document).off('input', `.js-create-sale-item-quantity-${i}`);
      $(document).off('input', `.js-create-sale-item-price-${i}`);
      $(document).off('input', `.js-create-sale-item-total-${i}`);
    }
    createSaleFormData.current.items = [];
    renderSaleCreationErrors();
  }

  // Limpa todos os métodos de pagamento da venda
  const deleteAllSaleCreatePaymentMethods = () => {
    for (let i = 0; i < createSaleFormData.current.paymentMethods.length; i++) {
      $(`.js-create-sale-item-method-${i}`).select2('destroy');
      $(document).off('input', `.js-create-sale-item-value-${i}`);
      $(document).off('input', `.js-create-sale-item-acquirer-${i}`);
      $(document).off('input', `.js-create-sale-item-condition-${i}`);
      $(document).off('change', `.js-create-sale-item-brand-${i}`);
      $(document).off('change', `.js-create-sale-item-financial-account-${i}`);
      //$(document).off('click', `.js-create-sale-remove-payment-method-${i}`);
      $(document).off('click', `.js-create-sale-item-method-clear-button-${i}`)
    }
    createSaleFormData.current.paymentMethods = [];
    renderSaleCreationErrors();
  }

  // Renderiza os itens da venda
  const renderSaleCreateItems = (onCreate = false) => {
    let html = '';
    if (createSaleFormData.current !== null) {
      for (let i = 0; i < createSaleFormData.current.items.length; i++) {
        html += `
          <tr>
            <td class="js-create-sale-item-name-${i}-container">
              <select class="form-select js-create-sale-item-name-${i}" required>
                <option value="">Selecione o item</option>
              </select>
              <a href="#" class="js-create-sale-item-name-clear-button-${i}">
                Limpar produto
              </a>
            </td>
            <td>
              <input type="text" class="form-control js-create-sale-item-details-${i}" placeholder="Detalhes" value="${createSaleFormData.current.items[i].details}" />
            </td>
            <td>
              <input type="number" class="form-control js-create-sale-item-quantity-${i}" placeholder="Quantidade" value="${createSaleFormData.current.items[i].quantity}" required />
            </td>
            <td>
              <input type="text" class="form-control js-create-sale-item-price-${i} mMoney" placeholder="Preço" value="${float2moeda(createSaleFormData.current.items[i].price)}" required />
            </td>
            <td>
              <input type="text" class="form-control js-create-sale-item-total-${i} mMoney" placeholder="Total" value="${float2moeda(createSaleFormData.current.items[i].total)}" readonly />
            </td>
            <td>
              <button type="button" class="btn btn-sm btn-danger js-create-sale-remove-item" data-index="${i}">
                <i class="fas fa-trash-alt"></i>
              </button>
            </td>
          </tr>
        `;
      }
    }

    $('#create-sale-items-table-body').html(html);

    if (onCreate) {
      window.reloadMasks();
    }

    handleSaleCreateItemInputs();
  }

  // Detecta clique no botão de adicionar método de pagamento
  const handleSaleCreateAddPaymentMethods = () => {
    // Detecta clique no botão de adicionar método de pagamento
    $(document).on('click', '.js-create-sale-add-payment-method', function () {
      let isAdminButton = $(this).data('is-admin');
      if (createSaleFormData.current.items.length == 0) {
        return window.toast({
          error: true,
          text: 'Adicione pelo menos um item à venda.'
        });
      }
      if (createSaleFormData.current.branch == -1) {
        return window.toast({
          error: true,
          text: 'Selecione uma filial.'
        });
      }
      if (createSaleFormData.current.date == null) {
        return window.toast({
          error: true,
          text: 'Selecione uma data.'
        });
      }
      if (createSaleFormData.current.customerId == -1) {
        return window.toast({
          error: true,
          text: 'Selecione um cliente.'
        });
      }
      if (createSaleFormData.current.sellerId == -1) {
        return window.toast({
          error: true,
          text: 'Selecione um vendedor.'
        });
      }
      if (createSaleFormData.current.stone && !isAdminButton) {
        if (createSaleFormData.current.isCreatingStoneOrder) {
          return window.toast({
            error: true,
            text: 'Não é possível iniciar uma nova transação Stone enquanto outra transação Stone está sendo criada.'
          });
        }
        return OnInitStonePaymentProcess();
      }
      if (createSaleFormData.current.stone && isAdminButton) {
        if (!userHasRole('ADMIN')) {
          return window.toast({
            error: true,
            text: 'Você não tem permissão para adicionar uma forma de pagamento.'
          });
        }
      }
      createSaleFormData.current.paymentMethods.push({
        id: -1,
        method: null,
        value: 0,
        condition: null, // a vista ou qtd parcelas
        acquirer: null,
        brand: null,
        info: null,
        financialAccountId: null
      });
      renderSaleCreatePaymentMethods(true);
      renderSaleCreationErrors();
    });

    // Detecta clique no botão de remover método de pagamento
    $(document).on('click', '.js-create-sale-remove-payment-method', function () {
      if (createSaleIsEdit.current) {
        if (createSaleFormData.current.status != 'EM_ABERTO') {
          return window.toast({
            error: true,
            text: 'Não é possível remover o método de pagamento pois a venda já foi criada.'
          });
        }
      }
      const index = $(this).data('index');
      if (index >= 0) {
        createSaleFormData.current.paymentMethods.splice(index, 1);
        renderSaleCreatePaymentMethods();
        renderPaymentMethodsPreview();
        renderSaleCreationErrors();
      }
    });
  }

  // Chamado ao iniciar processo de recebimento via Stone
  const OnInitStonePaymentProcess = () => {
    // check if modal is shown
    if (!$('#modal-sale-stone-payment-screen').is(':visible')) {
      $('#modal-sale-stone-payment-screen').modal('show');
    }

    $('.js-modal-sale-stone-payment-screen-close').prop('disabled', false);

    const totalFloat = createSaleFormData.current.total;
    const total = float2moeda(createSaleFormData.current.total);
    let totalPaid = 0;

    let paymentMethodsTableBodyHTML = '';
    if (createSaleFormData.current.paymentMethods.length > 0) {
      for (let i = 0; i < createSaleFormData.current.paymentMethods.length; i++) {
        let value = parseFloat(createSaleFormData.current.paymentMethods[i].value);
        if (isNaN(value)) {
          value = 0;
        }
        totalPaid += value;
        paymentMethodsTableBodyHTML += `
          <tr>
            <td>${createSaleFormData.current.paymentMethods[i].method}</td>
            <td>R$ ${createSaleFormData.current.paymentMethods[i].value}</td>
          </tr>
        `;
      }
    }

    const totalRemaining = totalFloat - totalPaid;

    if (totalPaid > 0) {
      if (!createSaleIsEdit.current) {
        setInterval(() => {
          $('.js-modal-sale-stone-payment-screen-close').prop('disabled', true);
        }, 500);
      }
    } else {
      paymentMethodsTableBodyHTML += `
        <tr>
          <td colspan="2">Aguardando pagamento...</td>
        </tr>
      `;
    }

    const html = `
      <div class="text-center p-4">
        <h3 class="mb-3 fw-bold">Total: R$ ${total}</h3>
        <p class="mb-4 fs-3">Total pago: <span class="fw-bold text-success">R$ ${totalPaid}</span></p>
        <p class="mb-4 fs-2">Valor a pagar: <span class="fw-bold text-primary">R$ ${totalRemaining}</span></p>

        ${totalPaid > 0 ? `
          <button type="button" class="btn btn-primary btn-lg js-stone-payment-finalize mb-3" data-sale-id="${createSaleFormData.current.stoneSaleId}">Finalizar venda</button>  
        ` : ''}
        
        ${totalPaid < totalFloat ? `
          <div class="col-lg-8 mx-auto mb-3">
            <legend>Escolha o valor e as parcelas (caso seja no crédito)</legend>
            <div class="row">
              <div class="col-6">
                <div class="form-label">Valor a cobrar</div>
                <input type="text" class="form-control js-stone-payment-amount mMoney" placeholder="Valor a pagar" value="${totalRemaining * 100}">
              </div>

              <div class="col-6">
                <div class="form-label">Parcelas</div>
                <input type="number" class="form-control js-stone-payment-installments" placeholder="Parcelas" min="1" max="12" value="1">
              </div>
            </div>
          </div>
          
          <div class="d-grid gap-1 col-lg-8 mb-3 mx-auto">
            <legend>Escolha a forma de pagamento</legend>
            <button class="btn btn-outline-primary btn-lg js-stone-payment-debit">
              <i class="fas fa-credit-card me-2"></i> DÉBITO
            </button>
            <button class="btn btn-outline-secondary btn-lg js-stone-payment-credit">
              <i class="fas fa-credit-card me-2"></i> CRÉDITO
            </button>
            <button class="btn btn-outline-info btn-lg js-stone-payment-pix">
              <i class="brands fa-pix me-2"></i> PIX
            </button>
          </div>
        ` : ''}

        <div class="d-grid gap-1 col-lg-8 mb-3 mx-auto">
          <legend>Pagamentos realizados</legend>
          <table class="table table-bordered mb-3">
            <thead>
              <tr>
                <th>Método</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody class="js-stone-payment-methods">
              ${paymentMethodsTableBodyHTML}
            </tbody>
          </table>
        </div>
        
        <div class="mt-4 pt-2 border-top">
          <p class="text-muted small mb-0">
            <i class="fas fa-info-circle me-1"></i>
            Assim que o pagamento for recebido, uma venda será criada internamente.
          </p>
        </div>
      </div>
    `;

    $('.js-stone-payment-screen').html(html);
    window.reloadMasks();
  }

  const handleStoneIntegrationScreenInputs = () => {
    // Unbind previous events to avoid duplication since this might be called multiple times
    $(document).off('click', '.js-modal-sale-stone-payment-screen-close');
    $(document).off('click', '.js-stone-payment-debit');
    $(document).off('click', '.js-stone-payment-credit');
    $(document).off('click', '.js-stone-payment-pix');

    // Detecta clique para fechar modal de métodos de pagamento
    $(document).on('click', '.js-modal-sale-stone-payment-screen-close', function (e) {
      if (createSaleFormData.current.isCreatingStoneOrder) {
        e.preventDefault();
        window.toast({
          error: true,
          text: 'Não é possível fechar a tela de pagamento pois uma transação Stone está sendo criada.'
        });
        return;
      }

      // If we are just at the selection screen (no order ID yet), just close
      if (!createSaleFormData.current.stoneSaleId) {
        $('#modal-sale-stone-payment-screen').modal('hide');
        return;
      }

      $('.js-stone-payment-screen').html('<div class="text-center p-4"><h3>Cancelando pedido...</h3></div>');
      //$('#modal-sale-stone-payment-screen').modal('hide'); // Don't hide immediately when cancelling? Reverting to original logic behavior.
      createSaleFormData.current.stoneSaleId = null;

      cancelStoneOrder(createSaleFormData.current.stoneCurrentOrderId);
    });

    // Detecta clique em "Tentar novamente" na tela onde já existe uma transação aberta na Stone
    $(document).on('click', '.js-stone-payment-screen-close', function () {
      let orderId = $(this).data('order-id');
      cancelStoneOrder(orderId, true);
    });

    // Payment Selection Handlers
    $(document).on('click', '.js-stone-payment-debit', function () {
      let stoneOrderValue = $('.js-stone-payment-amount').val();
      let stoneInstallments = parseInt($('.js-stone-payment-installments').val());
      createStoneOrder('debit', stoneOrderValue, stoneInstallments);
    });

    $(document).on('click', '.js-stone-payment-credit', function () {
      let stoneOrderValue = $('.js-stone-payment-amount').val();
      let stoneInstallments = parseInt($('.js-stone-payment-installments').val());
      createStoneOrder('credit', stoneOrderValue, stoneInstallments);
    });

    $(document).on('click', '.js-stone-payment-pix', function () {
      let stoneOrderValue = $('.js-stone-payment-amount').val();
      let stoneInstallments = parseInt($('.js-stone-payment-installments').val());
      createStoneOrder('pix', stoneOrderValue, stoneInstallments);
    });

    $(document).on('click', '.js-stone-payment-try-again', function () {
      OnInitStonePaymentProcess();
    });

    $(document).on('click', '.js-stone-payment-finalize', function () {
      let saleId = $(this).data('sale-id');
      if (!createSaleIsEdit.current) {
        Swal.fire({
          title: 'Finalizar venda',
          text: 'Deseja finalizar a venda?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não'
        }).then((result) => {
          if (result.isConfirmed) {
            // close stone payment modal
            if ($('#modal-sale-stone-payment-screen').is(':visible')) {
              $('#modal-sale-stone-payment-screen').modal('hide');
            }
            // close create sale modal
            if ($('#modal-sale-create').is(':visible')) {
              $('#modal-sale-create').modal('hide');
            }
            Swal.fire({
              icon: 'success',
              title: 'Venda finalizada.',
              text: 'Por favor, aguarde para que a venda seja aberta.',
            });
            saleCheckerIntv.current = setInterval(() => {
              if ($('.js-view-sale-details-row[data-id="' + saleId + '"]').length > 0) {
                clearInterval(saleCheckerIntv.current);
                $('.js-view-sale-details-row[data-id="' + saleId + '"]').trigger('click');
              }
            }, 1000);
          }
        });
      } else {
        if ($('#modal-sale-stone-payment-screen').is(':visible')) {
          $('#modal-sale-stone-payment-screen').modal('hide');
        }
        // reload edit modal view
        OnOpenSaleEditMode(null, saleId);
      }
      fetchTableData();
    })

    window.addEventListener("beforeunload", (event) => {
      // check if modal-create-sale modal is visible
      if ($('#modal-sale-create').is(':visible')) {
        // Most modern browsers require calling preventDefault() to trigger the dialog
        event.preventDefault();

        // Set the returnValue property for legacy support (e.g., older Chrome/Edge)
        event.returnValue = '';
      }
    });
  }

  // Helper to create order
  const createStoneOrder = (paymentType, stoneOrderValue, stoneInstallments) => {
    if (paymentType == 'debit' || paymentType == 'pix') {
      stoneInstallments = 1;
    }

    let validateValue = moeda2float(stoneOrderValue);
    console.log('validateValue', validateValue);
    console.log('createSaleFormData.current.total', createSaleFormData.current.total);

    if (validateValue < 1) {
      return window.toast({
        error: true,
        text: 'O valor deve ser maior que R$ 0,01.'
      });
    }
    if (validateValue > createSaleFormData.current.total) {
      return window.toast({
        error: true,
        text: 'O valor deve ser menor ou igual ao total da venda (R$ ' + float2moeda(createSaleFormData.current.total) + ').'
      });
    }

    $('.js-stone-payment-screen').html('<div class="text-center p-4"><h1><i class="fas fa-spinner fa-spin me-2"></i>Carregando...</h1></div>');
    createSaleFormData.current.isCreatingStoneOrder = true;

    $('.js-modal-sale-stone-payment-screen-close').prop('disabled', true);

    apiCall({
      endpoint: 'api/v1/sale/payment/create-order',
      method: 'POST',
      data: {
        ...createSaleFormData.current,
        stonePaymentMethod: paymentType,
        stoneOrderValue: validateValue,
        stoneInstallments: stoneInstallments,
        saleId: createSaleFormData.current.stoneSaleId
      },
      successCallback: (response) => {
        createSaleFormData.current.isCreatingStoneOrder = false;
        if (response.error) {
          //$('#modal-sale-stone-payment-screen').modal('hide'); 
          createSaleFormData.current.stoneSaleId = null;
          createSaleFormData.current.stoneCurrentOrderId = null;
          // Re-render selection screen on error? Or just show error?
          $('.js-stone-payment-screen').html(`<div class="text-center p-4"><h3 class="text-danger">Erro: ${response.message || 'Não foi possível criar a venda.'}</h3><button class="btn btn-secondary mt-3 js-stone-payment-try-again">Tentar Novamente</button></div>`);

          return window.toast({
            error: true,
            text: 'Não foi possível criar a venda.'
          });
        }
        createSaleFormData.current.stoneCurrentOrderId = response.data.id;
        createSaleFormData.current.stoneSaleId = response.saleId;
        startStoneOrderPaymentCheck();
        $('.js-stone-payment-screen').html('<div class="text-center p-4"><h1>Aguardando pagamento...</h1><button type="button" class="btn btn-secondary mt-3 js-stone-payment-screen-close" data-order-id="' + response.data.id + '">Cancelar Transação</button><p class="text-muted">Siga as instruções na máquina de cartão.</p></div>');
      },
      errorCallback: (response) => {
        $('.js-stone-payment-screen').html('<div class="text-center p-4"><h3 class="text-danger">Erro ao criar a venda.</h3></div>');
        createSaleFormData.current.isCreatingStoneOrder = false;
      }
    });
  }

  const cancelStoneOrder = (orderId, showPaymentScreen = false) => {
    createSaleFormData.current.isCreatingStoneOrder = true;

    if (stoneOrderPaymentCheckInterval.current !== null) {
      clearInterval(stoneOrderPaymentCheckInterval.current);
    }

    if (stoneOrderPaymentCheckXHR.current !== null) {
      stoneOrderPaymentCheckXHR.current.abort();
    }

    if (showPaymentScreen) {
      window.toast({
        error: false,
        text: "Aguarde enquanto a transação é cancelada."
      })
      $('.js-stone-payment-screen-close').prop('disabled', true);
    }

    apiCall({
      endpoint: 'api/v1/sale/payment/close-order',
      method: 'POST',
      data: {
        branch: createSaleFormData.current.branch,
        id: orderId,
        status: 'canceled'
      },
      successCallback: (response) => {
        $('.js-stone-payment-screen').html('<div class="text-center p-4"><h3>Pedido cancelado.</h3></div>');
        createSaleFormData.current.isCreatingStoneOrder = false;
        createSaleFormData.current.stoneCurrentOrderId = null;

        if (showPaymentScreen) {
          OnInitStonePaymentProcess();
          Swal.fire({
            icon: 'success',
            title: 'Transação cancelada.',
            text: 'A transação foi cancelada com sucesso.',
          });
        }

        console.log(response);
      },
      errorCallback: (response) => {
        //$('.js-stone-payment-screen').html('<div class="text-center p-4"><h3 class="text-danger">Erro ao cancelar o pedido.</h3></div>');
        Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro ao cancelar a transação',
          text: 'Caso o erro permaneça, entre em contato com o suporte.'
        });
        $('.js-stone-payment-screen-close').prop('disabled', false);

        createSaleFormData.current.isCreatingStoneOrder = false;

        console.error(response);
      }
    })
  }

  const startStoneOrderPaymentCheck = () => {
    if (stoneOrderPaymentCheckInterval.current !== null) {
      clearInterval(stoneOrderPaymentCheckInterval.current);
    }
    stoneOrderPaymentCheckInterval.current = setInterval(checkStoneOrderPaymentStatus, 5000);
  }

  const checkStoneOrderPaymentStatus = () => {
    stoneOrderPaymentCheckXHR.current = apiCall({
      endpoint: 'api/v1/sale/payment/check-order-payment',
      method: 'GET',
      data: {
        id: createSaleFormData.current.stoneCurrentOrderId
      },
      successCallback: (response) => {
        stoneOrderPaymentCheckXHR.current = null;
        console.log(response);
        if (response.error) {
          Swal.fire({
            icon: 'error',
            title: 'A transação não foi concluída.',
            text: response.message,
          });
          OnInitStonePaymentProcess();
        } else {
          if (response.paymentData.ID) {
            Swal.fire({
              icon: 'success',
              title: 'Transação concluída.',
              text: 'A transação foi concluída com sucesso.',
            });
            createSaleFormData.current.paymentMethods.push({
              id: response.installmentData.FORMA_PAGAMENTO_ID,
              method: response.installmentData.NOME,
              value: parseFloat(response.installmentData.VALOR_PARCELA),
              condition: response.installmentData.OBS,
              acquirer: response.installmentData.ADQUIRENTE_ID,
              brand: response.installmentData.BANDEIRA_ID,
              financialAccountId: response.installmentData.CONTA_BANCARIA_ID,
              info: response.installmentData
            })
            clearInterval(stoneOrderPaymentCheckInterval.current);
            stoneOrderPaymentCheckInterval.current = null;
            OnInitStonePaymentProcess();
          } else {
            console.log('aguardando pagamento?');
          }
        }
      },
      errorCallback: (response) => {
        stoneOrderPaymentCheckXHR.current = null;
        console.log(response);
      }
    })
  }

  // Renderiza os métodos de pagamento
  const renderSaleCreatePaymentMethods = (onCreate = false) => {
    let html = '';
    if (createSaleFormData.current !== null) {
      for (let i = 0; i < createSaleFormData.current.paymentMethods.length; i++) {

        let isBlockedForEdit = false;
        if (createSaleFormData.current.paymentMethods[i]?.info?.RECEBIMENTO_ID != null) {
          isBlockedForEdit = true;
        }

        html += `
          <tr>
              <td class="js-create-sale-item-method-${i}-container">
                  <select class="form-select js-create-sale-item-method-${i}" required ${isBlockedForEdit ? 'disabled' : ''}>
                    <option value="">Selecione o método</option>
                  </select>
                  <a href="#" class="js-create-sale-item-method-clear-button-${i}">
                    Limpar método
                  </a>
              </td>
              <td>
                <input type="text" class="form-control js-create-sale-item-value-${i} mMoney" placeholder="Valor" value="${float2moeda(createSaleFormData.current.paymentMethods[i].value)}" required ${isBlockedForEdit ? 'disabled' : ''} />
              </td>
              <td class="js-create-sale-item-acquirer-${i}-container">
                Sem adquirente
              </td>
              <td class="js-create-sale-item-brand-${i}-container">
                Sem bandeira
              </td>
              <td>
                <select class="form-select js-create-sale-item-condition-${i}" required ${isBlockedForEdit ? 'disabled' : ''}>
                  <option value="" selected disabled>Selecione a condição</option>
                </select>
              </td>
              <td>
                  <button type="button" class="btn btn-sm btn-danger js-create-sale-remove-payment-method" data-index="${i}" ${isBlockedForEdit ? 'disabled' : ''}>
                    <i class="fas fa-trash-alt"></i>
                  </button>
              </td>
          </tr>
        `;
      }
    }

    $('#create-sale-payment-methods-table-body').html(html);

    if (onCreate) {
      window.reloadMasks();
    }

    handleSaleCreatePaymentMethodInputs();
  }

  // Configura os inputs dos métodos de pagamento
  const handleSaleCreatePaymentMethodInputs = () => {
    if (createSaleFormData.current === null) {
      return;
    }

    for (let i = 0; i < createSaleFormData.current.paymentMethods.length; i++) {

      let isBlockedForEdit = false;
      if (createSaleFormData.current.paymentMethods[i]?.info?.RECEBIMENTO_ID != null) {
        isBlockedForEdit = true;
      }

      // Configura o select do método de pagamento
      $(`.js-create-sale-item-method-${i}`).select2({
        placeholder: "Selecione o método",
        theme: 'bootstrap-5',
        dropdownParent: $(`.js-create-sale-item-method-${i}-container`),
        minimumInputLength: 0,
        ajax: {
          url: getBaseDir() + 'api/v1/sale/payment-methods',
          delay: 1000,
          data: function (params) {
            var query = {
              search: params.term,
              page: params.page || 1
            }
            return query;
          },
          processResults: function (data, params) {
            params.page = params.page || 1;

            var results = [];
            $.each(data.data, function (k, v) {
              results.push({
                id: v.ID,
                text: v.NOME,
                info: v
              });
            });

            return {
              results: results,
              pagination: {
                more: (params.page * 10) < data.count_filtered
              }
            };
          }
        }
      });

      // if payment method method is not null, then show the payment method select in select2
      if (createSaleFormData.current.paymentMethods[i].id != null && createSaleFormData.current.paymentMethods[i].method != null) {
        setTimeout(() => {
          $(`.js-create-sale-item-method-${i}`).html(`<option value="${createSaleFormData.current.paymentMethods[i].id}" selected>${createSaleFormData.current.paymentMethods[i].method}</option>`);
          $(`.js-create-sale-item-method-${i}`).val(createSaleFormData.current.paymentMethods[i].id).trigger('select2:select');
        }, 290);
      }

      // Detecta alteração na seleção do método de pagamento
      $(`.js-create-sale-item-method-${i}`).on('select2:select', function (e) {
        if (!e.params) {
          e.params = {
            data: {
              id: createSaleFormData.current.paymentMethods[i].id,
              info: createSaleFormData.current.paymentMethods[i].info
            }

          }
          //console.log('e.params.data.info', e.params.data.info);
        }
        createSaleFormData.current.paymentMethods[i].id = e.params.data.id;
        createSaleFormData.current.paymentMethods[i].method = e.params.data.info.NOME;
        createSaleFormData.current.paymentMethods[i].info = e.params.data.info;

        // if ADQUIRENTES_IDS is not null, then show the acquirer select
        if (e.params.data.info.ADQUIRENTES_IDS != null) {

        } else {
          createSaleFormData.current.paymentMethods[i].acquirer = null;
        }

        if (e.params.data.info.MAX_PARCELAS != null) {
          // Não precisamos resetar aqui pq a cada novo metodo adicionado, ele deve manter a condição selecionada anteriormente
          //createSaleFormData.current.paymentMethods[i].condition = 1;

          let html = `<option value="" selected disabled>Selecione a condição</option>`;
          for (let j = 1; j <= e.params.data.info.MAX_PARCELAS; j++) {
            html += `<option value="${j}" ${createSaleFormData.current.paymentMethods[i].condition == j ? 'selected' : ''}>${j}x</option>`;
          }
          $(`.js-create-sale-item-condition-${i}`).html(html);

          apiCall({
            endpoint: 'api/v1/sale/payment-methods/acquirers',
            method: 'GET',
            data: {
              paymentMethodId: e.params.data.info.ID,
              acquirerIds: e.params.data.info.ADQUIRENTES_IDS
            },
            successCallback: (response) => {
              currentAcquirerersData.current = response.data;
              let html = `<select class="form-select js-create-sale-item-acquirer-${i}" required ${isBlockedForEdit ? 'disabled' : ''}><option value="">Selecione o adquirente</option>`;
              $.each(response.data, function (k, v) {
                html += `<option value="${v.ID}" data-info='${JSON.stringify(v)}' ${createSaleFormData.current.paymentMethods[i].acquirer == v.ID ? 'selected' : ''}>${v.NOME}</option>`;
              });
              html += `</select>`;
              $(`.js-create-sale-item-acquirer-${i}-container`).html(html);


              if (createSaleFormData.current.paymentMethods[i].acquirer != null && createSaleFormData.current.paymentMethods[i].brand != null) {
                let adquirenteData = currentAcquirerersData.current.find(item => item.ID == createSaleFormData.current.paymentMethods[i].acquirer);
                if (adquirenteData.BANDEIRAS.length > 0) {
                  let html = `<select class="form-select js-create-sale-item-brand-${i}" required><option value="">Selecione a bandeira</option>`;
                  $.each(adquirenteData.BANDEIRAS, function (k, v) {
                    html += `<option value="${v.ID}" ${createSaleFormData.current.paymentMethods[i].brand == v.ID ? 'selected' : ''}>${v.BANDEIRA}</option>`;
                  });
                  html += `</select>`;
                  $(`.js-create-sale-item-brand-${i}-container`).html(html);
                } else {
                  $(`.js-create-sale-item-brand-${i}-container`).html('Sem bandeira');
                }
              }

              if (createSaleIsEdit.current) {
                if (createSaleFormData.current.status != 'EM_ABERTO') {
                  $(`.js-create-sale-item-acquirer-${i}`).prop('disabled', true);
                  $(`.js-create-sale-item-brand-${i}`).prop('disabled', true);
                }
              }
            },
            errorCallback: (err) => {
              console.error('error', err);
            }
          });
        } else {
          createSaleFormData.current.paymentMethods[i].acquirer = null;
          createSaleFormData.current.paymentMethods[i].condition = null;
          createSaleFormData.current.paymentMethods[i].brand = null;
          $(`.js-create-sale-item-acquirer-${i}-container`).html('Sem adquirente');
          $(`.js-create-sale-item-brand-${i}-container`).html('Sem bandeira');
          $(`.js-create-sale-item-condition-${i}`).html(`
            <option value="1" selected disabled>À vista</option>
          `);
        }

        if (e.params.data.info.CONTAS_BANCARIAS != null) {
          if (e.params.data.info.CONTAS_BANCARIAS.length > 0) {
            let html = `<select class="form-select js-create-sale-item-financial-account-${i}" required ${isBlockedForEdit ? 'disabled' : ''}><option value="">Selecione a conta bancária</option>`;
            $.each(e.params.data.info.CONTAS_BANCARIAS, function (k, v) {
              html += `<option value="${v.ID}" ${createSaleFormData.current.paymentMethods[i].financialAccountId == v.ID ? 'selected' : ''}>${v.CONTA}</option>`;
            });
            html += `</select>`;
            $(`.js-create-sale-item-acquirer-${i}-container`).html(html);
          }

          if (createSaleIsEdit.current) {
            if (createSaleFormData.current.status != 'EM_ABERTO') {
              $(`.js-create-sale-item-financial-account-${i}`).prop('disabled', true);
            }
          }
        }
      });

      // Detecta alteração no valor do método de pagamento
      $(document).on('input', `.js-create-sale-item-value-${i}`, function () {
        createSaleFormData.current.paymentMethods[i].value = moeda2float($(this).val());
        renderPaymentMethodsPreview();
        renderSaleCreationErrors();
      });

      // Detecta alteração na seleção do adquirente
      $(document).on('change', `.js-create-sale-item-acquirer-${i}`, function () {
        createSaleFormData.current.paymentMethods[i].acquirer = $(this).val();
        let adquirenteData = currentAcquirerersData.current.find(item => item.ID == createSaleFormData.current.paymentMethods[i].acquirer);
        if (adquirenteData !== undefined) {
          createSaleFormData.current.paymentMethods[i].financialAccountId = adquirenteData.CONTA_ID;
        }
        renderSaleCreationErrors();

        if (currentAcquirerersData.current !== null) {
          if (adquirenteData) {
            if (adquirenteData.BANDEIRAS.length > 0) {
              let html = `<select class="form-select js-create-sale-item-brand-${i}" required ${isBlockedForEdit ? 'disabled' : ''}><option value="">Selecione a bandeira</option>`;
              $.each(adquirenteData.BANDEIRAS, function (k, v) {
                html += `<option value="${v.ID}" ${createSaleFormData.current.paymentMethods[i].brand == v.ID ? 'selected' : ''}>${v.BANDEIRA}</option>`;
              });
              html += `</select>`;
              $(`.js-create-sale-item-brand-${i}-container`).html(html);
            } else {
              $(`.js-create-sale-item-brand-${i}-container`).html('Sem bandeira');
            }
          }
        }
      });

      $(document).on('change', `.js-create-sale-item-brand-${i}`, function () {
        createSaleFormData.current.paymentMethods[i].brand = $(this).val();
        renderSaleCreationErrors();
      });

      // Detecta alteração na seleção da condição de pagamento
      $(document).on('change', `.js-create-sale-item-condition-${i}`, function () {
        createSaleFormData.current.paymentMethods[i].condition = $(this).val();
        renderSaleCreationErrors();
      });

      // Detecta alteração na seleção da conta bancária
      $(document).on('change', `.js-create-sale-item-financial-account-${i}`, function () {
        createSaleFormData.current.paymentMethods[i].financialAccountId = $(this).val();
        renderSaleCreationErrors();
      });

      // Detecta clique no botão de limpar o método de pagamento
      $(document).on('click', `.js-create-sale-item-method-clear-button-${i}`, function () {
        if (createSaleIsEdit.current) {
          if (createSaleFormData.current.status != 'EM_ABERTO') {
            return window.toast({
              error: true,
              text: 'Não é possível limpar o item pois a venda já foi criada.'
            });
          }
        }
        $(`.js-create-sale-item-method-${i}`).val('').trigger('change');
        createSaleFormData.current.paymentMethods[i].id = -1;
        createSaleFormData.current.paymentMethods[i].method = null;
        createSaleFormData.current.paymentMethods[i].condition = null;
        createSaleFormData.current.paymentMethods[i].acquirer = null;
        createSaleFormData.current.paymentMethods[i].brand = null;
        createSaleFormData.current.paymentMethods[i].info = null;
        createSaleFormData.current.paymentMethods[i].financialAccountId = null;
        $(`.js-create-sale-item-value-${i}`).val(0);
        $(`.js-create-sale-item-acquirer-${i}-container`).html('Sem adquirente');
        $(`.js-create-sale-item-brand-${i}-container`).html('Sem bandeira');
        $(`.js-create-sale-item-condition-${i}`).html(`
          <option value="" selected disabled>Selecione a condição</option>
        `);
        renderSaleCreationErrors();
      });
    }
  }

  // Renderiza o preview do total da venda
  const renderTotalPreview = () => {
    let itemsTotal = 0;
    let discountTotal = 0;
    let total = 0;

    if (createSaleFormData.current !== null) {
      for (let i = 0; i < createSaleFormData.current.items.length; i++) {
        //console.log('renderTotalPreview', 'createSaleFormData.current.items[i]', createSaleFormData.current.items[i]);
        itemsTotal += parseFloat(createSaleFormData.current.items[i].total);
      }

      //console.log('renderTotalPreview', 'itemsTotal', itemsTotal);

      discountTotal = parseFloat(createSaleFormData.current.discountType === 'PERCENTAGE' ? itemsTotal * (createSaleFormData.current.discountValue / 100) : createSaleFormData.current.discountValue);
      if (isNaN(discountTotal)) {
        discountTotal = 0;
      }

      if (isNaN(itemsTotal)) {
        itemsTotal = 0;
      }

      total = itemsTotal - discountTotal;
      createSaleFormData.current.itemsTotal = itemsTotal;
      createSaleFormData.current.discountTotal = discountTotal;
      createSaleFormData.current.total = total;
    }

    $("#create-sale-total-preview").text(float2moeda(itemsTotal));
    $("#create-sale-discount-preview").text(float2moeda(discountTotal));
    $("#create-sale-total-to-pay-preview").text(float2moeda(total));

    renderSaleCreationErrors();
  }

  // Renderiza o preview do total pago
  const renderPaymentMethodsPreview = () => {
    let total = 0;
    if (createSaleFormData.current !== null) {
      for (let i = 0; i < createSaleFormData.current.paymentMethods.length; i++) {
        //console.log('renderPaymentMethodsPreview', 'createSaleFormData.current.paymentMethods[i]', createSaleFormData.current.paymentMethods[i].value);
        total = total + parseFloat(createSaleFormData.current.paymentMethods[i].value);
      }
    }
    //console.log('renderPaymentMethodsPreview', 'total', total);
    $("#create-sale-total-paid-preview").text(float2moeda(total));
  }

  // Renderiza os erros da criação da venda
  const renderSaleCreationErrors = () => {
    //console.log('createSaleCustomerData', createSaleCustomerData);
    //console.log('createSaleFormData', createSaleFormData);

    let errors = [];

    if (createSaleFormData.current === null) {
      // all errors
      errors['#create-sale-branch'] = ['Selecione uma filial', '#create-sale-branch'];
      errors['#create-sale-customer'] = ['Selecione um cliente', '#create-sale-customer'];
      errors['#create-sale-seller'] = ['Selecione um vendedor', '#create-sale-seller'];
      errors['#create-sale-date'] = ['Selecione a data da venda', '#create-sale-date'];
      errors['#create-sale-items'] = ['Adicione pelo menos um item', '#create-sale-items'];
      errors['#create-sale-payment-methods'] = ['Adicione pelo menos um método de pagamento', '#create-sale-payment-methods'];
      errors['#create-sale-total-to-pay'] = ['O total da venda não pode ser menor que 0', '#create-sale-total-to-pay'];
      errors['#create-sale-payment-methods-total-paid'] = ['O total pago não pode ser menor que o total da venda', '#create-sale-payment-methods-total-paid'];
      errors['#create-sale-notes'] = ['Adicione a observação da venda', '#create-sale-notes'];
    }

    if (createSaleCustomerData.current === null) {
      // all errors
      errors['#create-sale-customer'] = ['Selecione um cliente', '#create-sale-customer'];
    }

    if (createSaleFormData.current !== null) {
      if (createSaleFormData.current.branch === -1) {
        errors['#create-sale-branch'] = ['Selecione uma filial', '#create-sale-branch'];
      }

      if (createSaleCustomerData.current == null) {
        errors['#create-sale-customer'] = ['Selecione um cliente', '#create-sale-customer'];
      }

      if (createSaleFormData.current.customerId === -1) {
        errors['#create-sale-customer'] = ['Selecione um cliente', '#create-sale-customer'];
      }

      if (createSaleFormData.current.sellerId === -1) {
        errors['#create-sale-seller'] = ['Selecione um vendedor', '#create-sale-seller'];
      }

      if (createSaleFormData.current.date == null) {
        errors['#create-sale-date'] = ['Selecione a data da venda', '#create-sale-date'];
      }

      if (createSaleFormData.current.items.length == 0) {
        errors['#create-sale-items'] = ['Adicione pelo menos um item', '#create-sale-items'];
      }

      if (createSaleFormData.current.paymentMethods.length == 0) {
        errors['#create-sale-payment-methods'] = ['Adicione pelo menos um método de pagamento', '#create-sale-payment-methods'];
      }

      //console.log('createSaleFormData.current.notes', createSaleFormData.current.notes);

      if (createSaleFormData.current.items.length > 0) {
        for (let i = 0; i < createSaleFormData.current.items.length; i++) {
          if (createSaleFormData.current.items[i].id == -1) {
            errors['#create-sale-items-name-${i}'] = ['Escolha um produto', '#create-sale-items-name-${i}'];
            break;
          }
          if (createSaleFormData.current.items[i].price <= 0) {
            errors['#create-sale-items-price-${i}'] = ['O preço do item não pode ser zerado.', '#create-sale-items-price-${i}'];
            break;
          }
          if (createSaleFormData.current.items[i].quantity <= 0) {
            errors['#create-sale-items-quantity-${i}'] = ['A quantidade do item não pode ser zerada.', '#create-sale-items-quantity-${i}'];
            break;
          }
          if (createSaleFormData.current.items[i].total <= 0) {
            errors['#create-sale-items-total-${i}'] = ['O total do item não pode ser zerado.', '#create-sale-items-total-${i}'];
            break;
          }
        }
      }

      if (createSaleFormData.current.notes == null || createSaleFormData.current.notes == '') {
        errors['#create-sale-notes'] = ['Adicione a observação da venda (Ex: Se houver, colocar número da Autorização de CADA forma de pagamento)', '#create-sale-notes'];
      }

      if (createSaleFormData.current.paymentMethods.length > 0) {
        let hasZeroValue = false;
        for (let i = 0; i < createSaleFormData.current.paymentMethods.length; i++) {
          if (createSaleFormData.current.paymentMethods[i].id == -1) {
            errors['#create-sale-payment-methods-method-${i}'] = ['Escolha um método de pagamento', '#create-sale-payment-methods-method-${i}'];
            break;
          }
          if (createSaleFormData.current.paymentMethods[i].value <= 0) {
            errors['#create-sale-payment-methods-value-${i}'] = ['O valor do método de pagamento não pode ser zerado.', '#create-sale-payment-methods-value-${i}'];
            hasZeroValue = true;
            break;
          }
        }

        if (hasZeroValue) {
          return;
        }
      }

      /*if (total < 0) {
        errors['#create-sale-total-to-pay'] = ['O total da venda não pode ser menor que 0', '#create-sale-total-to-pay'];
      }*/

      let sumPaymentMethods = 0;
      for (let i = 0; i < createSaleFormData.current.paymentMethods.length; i++) {
        sumPaymentMethods = sumPaymentMethods + parseFloat(createSaleFormData.current.paymentMethods[i].value);
      }
      //console.log('renderSaleCreationErrors', 'sumPaymentMethods', sumPaymentMethods);

      if (sumPaymentMethods < createSaleFormData.current.total || sumPaymentMethods > createSaleFormData.current.total) {
        errors['#create-sale-payment-methods-total-paid'] = [`O total pago não pode ser maior ou menor que o total da venda (R$ ${float2moeda(createSaleFormData.current.total)})`, `#create-sale-payment-methods-total-paid`];
      }
    }

    //console.log('renderSaleCreationErrors', 'createSaleFormData', createSaleFormData);
    //console.log('renderSaleCreationErrors', 'errors', errors, Object.keys(errors));

    if (Object.keys(errors).length > 0) {
      let html = '';
      let countErrors = 1;
      for (let i in errors) {
        html += `<li><a href="javascript:void(0);" class="js-create-sale-click-error" data-error="${errors[i][1]}">${countErrors}. ${errors[i][0]}</a></li>`;
        countErrors++;
      }
      $('#create-sale-errors').html(html);
      $('#save-create-sale').prop('disabled', true);
    } else {
      $('#save-create-sale').prop('disabled', false);
      $('#create-sale-errors').html('Nenhum erro encontrado, tudo certo para salvar a venda!');
    }
  }

  // Detecta geração de conta corrente ou contrato
  const handleGenerateCorrenteOrContract = () => {

    let contractGeneratorData = {
      patientName: '',
      admissionDate: '',
      contractValue: '',
      sessionValue: '',
      isPartialPayment: false,
      generateContract: false,
      installments: [],
      saleId: -1,
      patientId: -1,
      itemId: -1,
      paymentMethodDescription: '',
      itemData: null
    }

    $(document).on('click', '.js-sale-view-item-corrente', function () {
      let itemId = $(this).data('item-id');
      console.log('handleGenerateCorrenteOrContract', 'itemId', itemId, 'viewSaleData.current', viewSaleData.current);
      let itemData = viewSaleData.current.ITENS.find(item => item.ID == itemId);
      console.log('handleGenerateCorrenteOrContract', 'itemData', itemData);

      contractGeneratorData.itemData = itemData;

      contractGeneratorData.patientName = itemData.NOME;
      contractGeneratorData.admissionDate = moment(viewSaleData.current.CRIADA_EM).format('YYYY-MM-DD');
      contractGeneratorData.contractValue = Number(itemData.VALOR_TOTAL);
      contractGeneratorData.sessionValue = Number(parseFloat(Number(itemData.VALOR_TOTAL) / Number(itemData.QT_SERVICO_PLANO)).toFixed(2));
      contractGeneratorData.isPartialPayment = false;
      contractGeneratorData.generateContract = false;
      contractGeneratorData.installments = [];
      contractGeneratorData.saleId = viewSaleData.current.ID;
      contractGeneratorData.patientId = viewSaleData.current.CLIENTE_ID;
      contractGeneratorData.itemId = itemId;
      contractGeneratorData.serviceName = itemData.NOME;
      contractGeneratorData.paymentMethodDescription = '';
      contractGeneratorData.currentAccountService2 = {
        generate: false,
        agendaState: 'Agendado',
        doctorId: -1,
        serviceId: -1,
        servicePrice: 0
      };

      //console.log('contractGeneratorData', contractGeneratorData);

      switch (itemData.TIPO) {
        case 0: {
          $('.js-sale-generate-contract-or-individual-session-modal-body').html(`
            <div class="row">
              <div class="col-12 mb-3">
                <h5>Geração de conta corrente do serviço</h5>
              </div>
              <div class="col-12 mb-3">
                <label>Nome do serviço</label>
                <input type="text" class="form-control" name="js-sale-generate-contract-or-individual-session-service-name" id="js-sale-generate-contract-or-individual-session-service-name" value="${itemData.NOME}" readonly />
              </div>
              <div class="col-12 mb-3">
                <label>Valor do serviço</label>
                <input type="text" class="form-control mMoney" name="js-sale-generate-contract-or-individual-session-service-value" id="js-sale-generate-contract-or-individual-session-service-value" value="${float2moeda(itemData.VALOR_TOTAL)}" data-base-value="${(itemData.VALOR_TOTAL)}" required readonly />
              </div>
              <div class="col-12 mb-3">
                <label>Estado na agenda <span class="req">*</span></label>
                <select class="form-control" name="js-sale-generate-contract-or-individual-session-service-status" id="js-sale-generate-contract-or-individual-session-service-status">
                  <option value="Agendado" ${viewSaleData.current.FILIAL_ID == 14 ? 'selected' : ''}>Agendado</option>
                  ${viewSaleData.current.FILIAL_ID == 14 ? `` : '<option value="Presente">Presente</option>'}
                </select>
              </div>
              ${viewSaleData.current.FILIAL_ID == 14 ? `
                <div class="col-12 mb-3">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" name="js-sale-generate-contract-or-individual-session-service-2-checkbox" id="js-sale-generate-contract-or-individual-session-service-2-checkbox" />
                    <label class="form-check-label" for="js-sale-generate-contract-or-individual-session-service-2-checkbox">Gerar conta corrente serviço 2?</label>
                  </div>
                </div>
                <div class="js-sale-generate-contract-or-individual-session-service-2-container d-none">
                  <div class="col-12 mb-3">
                    <label>Doutor(a) do serviço 2</label>
                    <select class="form-control js-business-doctors-selector" name="js-sale-generate-contract-or-individual-session-service-2-doctor" id="js-sale-generate-contract-or-individual-session-service-2-doctor">
                      <option value="">-- Selecione --</option>
                    </select>
                  </div>
                  <div class="col-12 mb-3">
                    <label>Serviço 2</label>
                    <select class="form-control js-contracts-service-list-2" name="js-sale-generate-contract-or-individual-session-service-2" id="js-sale-generate-contract-or-individual-session-service-2">
                      <option value="">-- Selecione --</option>
                    </select>
                  </div>
                  <div class="col-12 mb-3">
                    <label>Valor unitário com desconto do serviço 2</label>
                    <input type="text" class="form-control mMoney" name="js-sale-generate-contract-or-individual-session-service-2-price" id="js-sale-generate-contract-or-individual-session-service-2-price" value="" />
                  </div>
                </div>
              ` : ''}
              <div class="col-12 mb-3">
                <button type="button" class="btn btn-primary js-sale-generate-contract-or-individual-session-generate-contract" data-type="conta_corrente">Gerar conta corrente</button>
              </div>
            </div>
          `);

          getBusinessDoctorsListByBranchId(viewSaleData.current.FILIAL_ID, function (doctors) {
            //console.log('doctors', doctors);
          });

          apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/agenda_services',
            successCallback: function (res) {
              if (!res.error) {
                let html = '<option selected default value="">-- Selecione --</option>';
                for (let i = 0; i < res.data.length; i++) {
                  let service = res.data[i];
                  if (service.ID == 1 || service.ID == 3)
                    continue;
                  html += `<option value="${service.ID}" data-servico-info='${JSON.stringify(service)}'>${service.SERVICO}</option>`
                }
                let allowedComboServices = ['Massagem 15m', ' Escalda pés'];
                let htmlComboServices = '<option selected default value="">-- Selecione --</option>';
                for (let i = 0; i < res.data.length; i++) {
                  let service = res.data[i];
                  if (allowedComboServices.includes(service.SERVICO)) {
                    htmlComboServices += `<option value="${service.ID}" data-servico-info='${JSON.stringify(service)}'>${service.SERVICO}</option>`
                  }
                }
                //$('.js-contracts-service-list').html(html);
                $('.js-contracts-service-list-2').html(htmlComboServices);
              }
            },
            errorCallback: function (err) {
            }
          });
          break;
        }
        case 1: {
          $('.js-sale-generate-contract-or-individual-session-modal-body').html(`
            <div class="row">
              <div class="col-12 mb-3">
                <h5>Geração de contrato do plano<br>${itemData.NOME}</h5>
              </div>
              <div class="col-12 mb-3">
                <label>Nome do paciente</label>
                <input type="text" class="form-control" name="js-sale-generate-contract-or-individual-session-patient-name" id="js-sale-generate-contract-or-individual-session-patient-name" value="${viewSaleData.current.CLIENTE_NOME}" readonly required />
                <small class="text-muted">Ao iniciar o fluxo de assinatura do contrato, poderá configurar um responsável financeiro.</small>
              </div>
              <div class="col-12 mb-3">
                <label>Data de adesão <span class="req">*</span></label>
                <input type="date" class="form-control" name="js-sale-generate-contract-or-individual-session-admission-date" id="js-sale-generate-contract-or-individual-session-admission-date" value="${moment(viewSaleData.current.CRIADA_EM).format('YYYY-MM-DD')}" required />
              </div>
              <div class="col-12 mb-3">
                <label>Valor <b>total</b> do contrato (R$) <span class="req">*</span></label>
                <input type="text" class="form-control mMoney" name="js-sale-generate-contract-or-individual-session-contract-value" id="js-sale-generate-contract-or-individual-session-contract-value" required placeholder="${float2moeda(itemData.VALOR_TOTAL)}" />
              </div>
              <div class="col-12 mb-3">
                <label>Valor <b>por sessão</b> (R$)</label>
                <input type="text" class="form-control" name="js-sale-generate-contract-or-individual-session-session-value" id="js-sale-generate-contract-or-individual-session-session-value" required value="${contractGeneratorData.sessionValue}" readonly />
              </div>
              <div class="col-12 mb-3">
                <label>Forma de pagamento (por extenso) <span class="req">*</span></label>
                <textarea class="form-control" name="js-sale-generate-contract-or-individual-session-payment-method-description" id="js-sale-generate-contract-or-individual-session-payment-method-description" required></textarea>
              </div>
              <div class="col-12">
                <label>É um contrato pago parcialmente? <span class="req">*</span></label>
                <div class="form-group">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="js-sale-generate-contract-or-individual-session-is-partial-payment" id="js-sale-generate-contract-or-individual-session-is-partial-payment-yes" value="1" required>
                    <label class="form-check-label" for="js-sale-generate-contract-or-individual-session-is-partial-payment-yes">Sim</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="js-sale-generate-contract-or-individual-session-is-partial-payment" id="js-sale-generate-contract-or-individual-session-is-partial-payment-no" value="0" required>
                    <label class="form-check-label" for="js-sale-generate-contract-or-individual-session-is-partial-payment-no">Não</label>
                  </div>
                </div>
              </div>
              <div class="col-12 js-sale-generate-contract-or-individual-session-installments-container d-none">
                <div class="divider"></div>
                <div>
                  <h2>Formas de Pagamento</h2>
                  <div class="col-12 p-0 ml-0 mr-0 mb-3 js-sale-generate-contract-or-individual-session-payment-parcel-warning">
                    <p>O contrato está sendo pago parcialmente, por isso, você deve cadastrar os pagamentos que foram realizados hoje e futuros!</p>
                  </div>
                  <button type="button" class="btn btn-primary js-sale-generate-contract-or-individual-session-installments-add mb-2" data-bs-toggle="modal" data-bs-target="#modal-contract-insert-installments">Adicionar Parcela</button>
                  <table class="table table-bordered table-striped table-hover responsive-table">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Forma Pgto</th>
                        <th>Data Pagamento</th>
                        <th>Qt Parcelas</th>
                        <th>Vlr Parcela</th>
                        <th>Total</th>
                        <th>Obs</th>
                      </tr>
                    </thead>
                    <tbody class="js-sale-generate-contract-or-individual-session-installments-list">
                      <tr><td colspan="9">Cadastre os pagamentos, que foram realizados hoje e futuros!</td></tr>
                    </tbody>
                  </table>
                  <div class="row mb-4">
                    <div class="col-12">
                      <div class="card bg-light">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-4">
                              <h6 class="text-muted">Total contrato</h6>
                              <h4 class="text-primary js-sale-generate-contract-or-individual-session-total-to-pay">R$ ${float2moeda(contractGeneratorData.contractValue)}</h4>
                            </div>
                            <div class="col-4">
                              <h6 class="text-muted">Total parciais futuras</h6>
                              <h4 class="text-danger js-sale-generate-contract-or-individual-session-total-future-installments">R$ 0,00</h4>
                            </div>
                            <div class="col-4">
                              <h6 class="text-muted">Total pago (hoje)</h6>
                              <h4 class="text-success js-sale-generate-contract-or-individual-session-total-payment-methods">R$ 0,00</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              ${viewSaleData.current.FILIAL_ID == 14 ? `
                <div class="col-12 mb-2">
                  <h2>Combo</h2>
                  <div class="form-group">
                    <label for="sale_generate_contract_or_individual_session_combo">Este plano é um combo? <i class="fas fa-info-circle" data-tippy-content="Você poderá montar um combo de sessões extras de um serviço para o paciente."></i></label>
                    <select id="sale_generate_contract_or_individual_session_combo" name="sale_generate_contract_or_individual_session_combo" class="form-control form-control">
                      <option value="1">Sim</option>
                      <option value="0" selected>Não</option>
                    </select>
                  </div>

                  <div class="js-sale-generate-contract-or-individual-session-combo-container d-none">
                    <div class="form-group">
                      <label for="sale_generate_contract_combo_doctor_2_id">Doutor(a) do serviço 2 <span class="req">*</span> <i class="fas fa-info-circle" data-tippy-content="Você poderá montar um combo de sessões extras de um serviço para o paciente."></i></label>
                      <select id="sale_generate_contract_combo_doctor_2_id" name="sale_generate_contract_combo_doctor_2_id" class="form-control form-control js-business-doctors-selector">
                        <option selected default value="">-- Selecione --</option>
                      </select>
                    </div>
                    <div class="form-group">
                        <label for="sale_generate_contract_combo_service_2_id">Serviço 2 <i class="fas fa-info-circle" data-tippy-content="Esse serviço é opcional, caso o paciente não queira contratar, selecione Não"></i></label>
                        <select id="sale_generate_contract_combo_service_2_id" name="sale_generate_contract_combo_service_2_id" class="form-control form-control js-contracts-service-list-2">
                            <option selected default value="">-- Selecione --</option>
                        </select>
                    </div>
                    <div class="form-group">
                      <label for="sale_generate_contract_combo_quiro_masso_sessions">Qtd de sessões do serviço 2 <i class="fas fa-info-circle" data-tippy-content="Essa será a quantidade de sessões extras que o paciente terá acesso, esse valor não aparece no contrato"></i></label>
                      <input type="number" class="form-control" id="sale_generate_contract_combo_quiro_masso_sessions" name="sale_generate_contract_combo_quiro_masso_sessions" data-value="${itemData.QT_SERVICO_PLANO}" />
                    </div>
                    <div class="form-group">
                      <label for="sale_generate_contract_combo_quiro_price">Valor unitário com desconto do serviço 1 <i class="fas fa-info-circle" data-tippy-content="Esse é o valor unitário da sessão do serviço 1 com desconto, serve como base para cálculo da comissão do Doutor(a)"></i></label>
                      <input type="number" class="form-control" id="sale_generate_contract_combo_quiro_price" name="sale_generate_contract_combo_quiro_price" />
                    </div>
                    <div class="form-group">
                      <label for="sale_generate_contract_combo_quiro_masso_price">Valor unitário com desconto do serviço 2 <i class="fas fa-info-circle" data-tippy-content="Esse é o valor unitário da sessão do serviço 2 com desconto, serve como base para cálculo da comissão do Doutor(a)"></i></label>
                      <input type="number" class="form-control" id="sale_generate_contract_combo_quiro_masso_price" name="sale_generate_contract_combo_quiro_masso_price" />
                    </div>
                  </div>
                </div>
              ` : ''}
              <div class="col-12 js-sale-generate-contract-or-individual-session-generate-contract-container d-none">
                <button type="button" class="btn btn-primary js-sale-generate-contract-or-individual-session-generate-contract" data-type="contrato">Gerar contrato</button>
              </div>
            </div>
          `);

          //console.log('viewSaleData.current', viewSaleData.current);

          getBusinessDoctorsListByBranchId(viewSaleData.current.FILIAL_ID, function (doctors) {
            //console.log('doctors', doctors);
          });

          apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/agenda_services',
            successCallback: function (res) {
              if (!res.error) {
                let html = '<option selected default value="">-- Selecione --</option>';
                for (let i = 0; i < res.data.length; i++) {
                  let service = res.data[i];
                  if (service.ID == 1 || service.ID == 3)
                    continue;
                  html += `<option value="${service.ID}" data-servico-info='${JSON.stringify(service)}'>${service.SERVICO}</option>`
                }
                let allowedComboServices = ['Massagem 15m', ' Escalda pés'];
                let htmlComboServices = '<option selected default value="">-- Selecione --</option>';
                for (let i = 0; i < res.data.length; i++) {
                  let service = res.data[i];
                  if (allowedComboServices.includes(service.SERVICO)) {
                    htmlComboServices += `<option value="${service.ID}" data-servico-info='${JSON.stringify(service)}'>${service.SERVICO}</option>`
                  }
                }
                //$('.js-contracts-service-list').html(html);
                $('.js-contracts-service-list-2').html(htmlComboServices);
              }
            },
            errorCallback: function (err) {
            }
          });
          break;
        }
      }

      window.reloadIconss();
      $('#modal-sale-generate-contract-or-individual-session').modal('show');
    });

    $(document).on('change', '#js-sale-generate-contract-or-individual-session-contract-value', function () {
      contractGeneratorData.contractValue = moeda2float($(this).val());
      contractGeneratorData.sessionValue = moeda2float($(this).val()) / contractGeneratorData.itemData.QT_SERVICO_PLANO;
      //console.log('contractGeneratorData.contractValue', contractGeneratorData.contractValue);
      //console.log('contractGeneratorData.itemData.QT_SERVICO_PLANO', contractGeneratorData.itemData.QT_SERVICO_PLANO);
      //console.log('contractGeneratorData.sessionValue', contractGeneratorData.sessionValue);
      $('#js-sale-generate-contract-or-individual-session-session-value').val(contractGeneratorData.sessionValue);
      $('.js-sale-generate-contract-or-individual-session-total-to-pay').html(`R$ ${float2moeda(contractGeneratorData.contractValue)}`);
    });

    $(document).on('change', '#sale_generate_contract_or_individual_session_combo', function () {
      let value = $(this).val();
      if (value == 1) {
        $('.js-sale-generate-contract-or-individual-session-combo-container').removeClass('d-none');
        $('#sale_generate_contract_combo_quiro_masso_sessions').prop('required', true);
        $('#sale_generate_contract_combo_quiro_price').prop('required', true);
        $('#sale_generate_contract_combo_quiro_masso_price').prop('required', true);
        $('#sale_generate_contract_combo_service_2_id').prop('required', true);
        $('#sale_generate_contract_combo_doctor_2_id').prop('required', true);
        $('#sale_generate_contract_combo_quiro_masso_sessions').val($('#sale_generate_contract_combo_quiro_masso_sessions').data('value') || 1);
        //$('.js-contract-insert-submit-button').prop('disabled', true);
      } else {
        $('.js-sale-generate-contract-or-individual-session-combo-container').addClass('d-none');
        $('#sale_generate_contract_combo_quiro_masso_sessions').prop('required', false);
        $('#sale_generate_contract_combo_quiro_price').prop('required', false);
        $('#sale_generate_contract_combo_quiro_masso_price').prop('required', false);
        $('#sale_generate_contract_combo_service_2_id').prop('required', false);
        $('#sale_generate_contract_combo_doctor_2_id').prop('required', false);
        $('.js-sale-generate-contract-or-individual-session-submit-button').prop('disabled', false);
      }
    });

    // Detecta alteração na data de adesão
    $(document).on('change', '#js-sale-generate-contract-or-individual-session-admission-date', function () {
      let admissionDate = $(this).val();
      if (admissionDate) {
        contractGeneratorData.admissionDate = admissionDate;
      }
    });

    // Detecta clique no radio de contrato pago parcialmente
    $(document).on('click', 'input[name="js-sale-generate-contract-or-individual-session-is-partial-payment"]', function () {
      if ($(this).val() == '1') {
        $('.js-sale-generate-contract-or-individual-session-generate-contract-container').addClass('d-none');
        $('.js-sale-generate-contract-or-individual-session-installments-container').removeClass('d-none');
        $('.js-sale-generate-contract-or-individual-session-installments-list').html('');
        contractGeneratorData.installments = [];
        contractGeneratorData.isPartialPayment = true;
        $('.js-sale-generate-contract-or-individual-session-total-future-installments').html(`R$ 0,00`);
        $('.js-sale-generate-contract-or-individual-session-total-payment-methods').html(`R$ 0,00`);
      } else {
        $('.js-sale-generate-contract-or-individual-session-generate-contract-container').removeClass('d-none');
        $('.js-sale-generate-contract-or-individual-session-installments-container').addClass('d-none');
        $('.js-sale-generate-contract-or-individual-session-installments-list').html('');
        contractGeneratorData.installments = [];
        contractGeneratorData.isPartialPayment = false;
        $('.js-sale-generate-contract-or-individual-session-total-future-installments').html(`R$ 0,00`);
        $('.js-sale-generate-contract-or-individual-session-total-payment-methods').html(`R$ 0,00`);
      }
    });

    $(document).on('change', '#js-sale-generate-contract-or-individual-session-payment-method-description', function () {
      contractGeneratorData.paymentMethodDescription = $(this).val();
    });

    // Detecta alteração na quantidade de parcelas
    $(document).on('change', '#contract_insert_installments_installments', function () {
      console.log('moeda2float($(#contract_insert_installments_installment_value).val())', moeda2float($('#contract_insert_installments_installment_value').val()));
      let valorParcela = parseFloat(moeda2float($('#contract_insert_installments_installment_value').val())).toFixed(2);
      console.log('valorParcela', valorParcela);
      if (!isNaN(valorParcela)) {
        let qtParcelas = parseInt($(this).val());
        $('#contract_insert_installments_total').val(qtParcelas * valorParcela);
      }
    });

    // Detecta alteração no valor da parcela
    $(document).on('change', '#contract_insert_installments_installment_value', function () {
      let qtParcelas = parseInt($('#contract_insert_installments_installments').val());
      if (!isNaN(qtParcelas)) {
        console.log('moeda2float($(this).val())', moeda2float($(this).val()));
        let valorParcela = parseFloat(moeda2float($(this).val())).toFixed(2);
        console.log('valorParcela', valorParcela);
        $('#contract_insert_installments_total').val(qtParcelas * valorParcela);
      }
    });

    // Detecta submit do formulário de adição de parcelas
    $(document).on('submit', '.js-contract-insert-installments-form', function (e) {
      e.preventDefault();
      let serializeData = $(this).serializeArray();
      let contractTotal = contractGeneratorData.contractValue;
      console.log(serializeData);

      let sumTotalPaidValues = 0; // Inicializa como número
      let onlyHasTodayPayments = 0;

      let paymentDateNewParcel = serializeData.find(item => item.name === 'contract_insert_installments_payment_date').value;

      if (contractGeneratorData.installments.length > 0) {
        contractGeneratorData.installments.forEach(installment => {
          sumTotalPaidValues += parseFloat(installment.VALOR_TOTAL); // Soma os valores como números
          if (moment(installment.DATA_PAGAMENTO).format('YYYY-MM-DD') == moment($('.js-sale-generate-contract-or-individual-session-admission-date').val()).format('YYYY-MM-DD')) {
            onlyHasTodayPayments++;
          }
        });
      }
      sumTotalPaidValues += parseFloat(serializeData.find(item => item.name === 'contract_insert_installments_total').value);
      sumTotalPaidValues = parseFloat(sumTotalPaidValues).toFixed(2); // Converte para string com 2 decimais apenas no final

      if (Number(sumTotalPaidValues) > Number(contractTotal))
        return window.toast({
          error: true,
          text: "O valor total das parcelas não deve ultrapassar R$ " + contractTotal + "!"
        })

      if (moment(paymentDateNewParcel).format('YYYY-MM-DD') < moment($('.js-sale-generate-contract-or-individual-session-admission-date').val()).format('YYYY-MM-DD')) {
        return window.toast({
          error: true,
          text: "A data de pagamento não pode ser anterior à data de adesão!"
        })
      }

      if (Number(sumTotalPaidValues) >= Number(contractTotal) && contractGeneratorData.isPartialPayment && contractGeneratorData.installments.length >= 0 && onlyHasTodayPayments == contractGeneratorData.installments.length && paymentDateNewParcel == moment($('.js-sale-generate-contract-or-individual-session-admission-date').val()).format('YYYY-MM-DD')) {
        return window.toast({
          error: true,
          text: "Se o pagamento é parcial, você deve cadastrar pelo menos uma parcela para outra data! (Não é possível cadastrar todas as parcelas para a mesma data)"
        });
      }

      let id = contractGeneratorData.installments.length + 1;
      contractGeneratorData.installments.push({
        ID: id,
        FORMA_PAGAMENTO: serializeData.find(item => item.name === 'contract_insert_installments_payment_method').value,
        DATA_PAGAMENTO: moment(serializeData.find(item => item.name === 'contract_insert_installments_payment_date').value).format('YYYY-MM-DD'),
        QT_PARCELAS: Number(serializeData.find(item => item.name === 'contract_insert_installments_installments').value),
        VALOR_PARCELA: moeda2float(serializeData.find(item => item.name === 'contract_insert_installments_installment_value').value),
        VALOR_TOTAL: moeda2float(serializeData.find(item => item.name === 'contract_insert_installments_total').value),
        OBSERVACAO: serializeData.find(item => item.name === 'contract_insert_installments_obs').value,
      });
      $('.js-sale-generate-contract-or-individual-session-installments-list').html(renderContractInsertInstallments());
    });

    // Detecta remoção de parcela
    $(document).on('click', '.js-contract-insert-installments-remove', function () {
      let installmentId = $(this).data('installment-id');
      contractGeneratorData.installments = contractGeneratorData.installments.filter(installment => installment.ID !== installmentId);
      $('.js-sale-generate-contract-or-individual-session-installments-list').html(renderContractInsertInstallments());
    });

    $(document).on('change', '#js-sale-generate-contract-or-individual-session-service-2-checkbox', function () {
      if ($(this).is(':checked')) {
        contractGeneratorData.currentAccountService2.generate = true;
        $('.js-sale-generate-contract-or-individual-session-service-2-container').removeClass('d-none');
        if (viewSaleData.current.FILIAL_ID == 14) {
          $('#js-sale-generate-contract-or-individual-session-service-value').attr('readonly', false);
          $('#js-sale-generate-contract-or-individual-session-service-value').prop('readonly', false);
          if (checkForOverpriceInCurrentAccount()) {
            $('.js-sale-generate-contract-or-individual-session-generate-contract').prop('disabled', true);
          }
        }
      } else {
        contractGeneratorData.currentAccountService2.generate = false;
        $('.js-sale-generate-contract-or-individual-session-service-2-container').addClass('d-none');
        if (viewSaleData.current.FILIAL_ID == 14) {
          $('#js-sale-generate-contract-or-individual-session-service-value').attr('readonly', true);
          $('#js-sale-generate-contract-or-individual-session-service-value').prop('readonly', true);
          if (checkForOverpriceInCurrentAccount()) {
            $('.js-sale-generate-contract-or-individual-session-generate-contract').prop('disabled', false);
          }
        }
      }
    });

    $(document).on('change', '#js-sale-generate-contract-or-individual-session-service-value', function () {
      contractGeneratorData.contractValue = moeda2float($(this).val());
      console.log('contractGeneratorData.contractValue', contractGeneratorData.contractValue);
      console.log('checkForOverpriceInCurrentAccount()', checkForOverpriceInCurrentAccount());
      if (checkForOverpriceInCurrentAccount()) {
        $('.js-sale-generate-contract-or-individual-session-generate-contract').prop('disabled', true);
        return window.toast({
          error: true,
          text: "O valor do serviço não pode ser maior que o valor base do item na venda (R$ " + $('#js-sale-generate-contract-or-individual-session-service-value').data('base-value') + ")!"
        })
      } else {
        $('.js-sale-generate-contract-or-individual-session-generate-contract').prop('disabled', false);
      }
    });

    $(document).on('change', '#js-sale-generate-contract-or-individual-session-service-2-doctor', function () {
      contractGeneratorData.currentAccountService2.doctorId = $(this).val();
    });

    $(document).on('change', '#js-sale-generate-contract-or-individual-session-service-status', function () {
      contractGeneratorData.currentAccountService2.agendaState = $(this).val();
    });

    $(document).on('change', '#js-sale-generate-contract-or-individual-session-service-2', function () {
      contractGeneratorData.currentAccountService2.serviceId = $(this).val();
    });

    $(document).on('change', '#js-sale-generate-contract-or-individual-session-service-2-price', function () {
      contractGeneratorData.currentAccountService2.servicePrice = moeda2float($(this).val());
      if (checkForOverpriceInCurrentAccount()) {
        $('.js-sale-generate-contract-or-individual-session-generate-contract').prop('disabled', true);
        return window.toast({
          error: true,
          text: "O valor do serviço não pode ser maior que o valor base do item na venda (R$ " + $('#js-sale-generate-contract-or-individual-session-service-value').data('base-value') + ")!"
        })
      } else {
        $('.js-sale-generate-contract-or-individual-session-generate-contract').prop('disabled', false);
      }
    });

    // Detecta geração de contrato
    $(document).on('click', '.js-sale-generate-contract-or-individual-session-generate-contract', function () {
      console.log('contractGeneratorData', contractGeneratorData);

      let type = $(this).data('type');
      let selfButton = $(this);
      selfButton.prop('disabled', true);

      if (type == 'contrato') {
        if (contractGeneratorData.paymentMethodDescription == '') {
          selfButton.prop('disabled', false);
          return window.toast({
            error: true,
            text: "Você deve informar a forma de pagamento (por extenso)!"
          })
        }

        Swal.fire({
          title: 'Geração de contrato',
          html: `
            Confirme os dados do contrato:<br><br>

            Nome do paciente: ${contractGeneratorData.patientName}<br>
            Data de adesão: ${contractGeneratorData.admissionDate}<br>
            Valor total do contrato: ${float2moeda(contractGeneratorData.contractValue)}<br>
            Valor por sessão: ${float2moeda(contractGeneratorData.sessionValue)}<br>
            É um contrato pago parcialmente? ${contractGeneratorData.isPartialPayment ? 'Sim' : 'Não'}<br>
            Formas de pagamento: ${contractGeneratorData.installments.map(installment => installment.FORMA_PAGAMENTO).join(', ')}<br>
          `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, gerar contrato',
          cancelButtonText: 'Cancelar',
        }).then((result) => {
          if (result.isConfirmed) {
            //console.log('Gerar contrato');
            //selfButton.prop('disabled', false);
            //console.log('contractGeneratorData', contractGeneratorData);

            let payload = {
              sale_id: viewSaleData.current.ID,
              type: type,
              data: {
                ...contractGeneratorData
              },
            }

            if ($('.js-sale-generate-contract-or-individual-session-combo-container').length > 0 && $('.js-sale-generate-contract-or-individual-session-combo-container').hasClass('d-none') == false) {
              payload.data.QUIROMASSO_SESSOES = Number($('#sale_generate_contract_combo_quiro_masso_sessions').val()) || 1;
              payload.data.QUIROMASSO_PRECO = $('#sale_generate_contract_combo_quiro_price').val();
              payload.data.QUIROMASSO_MASSO_PRECO = $('#sale_generate_contract_combo_quiro_masso_price').val();
              payload.data.QUIROMASSO_MASSO_SERVICO_ID = $('#sale_generate_contract_combo_service_2_id').val();
              payload.data.QUIROMASSO_MASSO_DOUTOR_ID = $('#sale_generate_contract_combo_doctor_2_id').val();

              if (payload.data.QUIROMASSO_SESSOES == 0) {
                payload.data.QUIROMASSO_SESSOES = 1;
              }
              if (payload.data.QUIROMASSO_PRECO.trim() == '') {
                selfButton.prop('disabled', false);
                return window.toast({
                  error: true,
                  text: "Você deve informar o valor do quiroprático!"
                })
              }
              if (payload.data.QUIROMASSO_MASSO_PRECO.trim() == '') {
                selfButton.prop('disabled', false);
                return window.toast({
                  error: true,
                  text: "Você deve informar o valor do masso!"
                })
              }
              if (payload.data.QUIROMASSO_MASSO_SERVICO_ID == 0 || payload.data.QUIROMASSO_MASSO_SERVICO_ID.trim() == '') {
                selfButton.prop('disabled', false);
                return window.toast({
                  error: true,
                  text: "Você deve informar o serviço do masso!"
                })
              }
              if (payload.data.QUIROMASSO_MASSO_DOUTOR_ID == 0 || payload.data.QUIROMASSO_MASSO_DOUTOR_ID.trim() == '') {
                selfButton.prop('disabled', false);
                return window.toast({
                  error: true,
                  text: "Você deve informar o doutor do masso!"
                })
              }
            }

            apiCall({
              endpoint: 'api/v1/sale/generate-service-asset',
              method: 'POST',
              data: payload,
              successCallback: function (response) {
                //console.log('response', response);
                window.toast({
                  error: response.error,
                  text: response.message
                })
                if (response.error) {
                  selfButton.prop('disabled', false);
                } else {
                  $('#modal-sale-generate-contract-or-individual-session').modal('hide');
                  let url = getBaseDir() + 'contratos/cadastros?' + $.param({
                    contract_id: response.PatientControllerReturn.contract_id,
                    branch: viewSaleData.current.FILIAL_ID
                  });
                  window.open(url, '_blank');
                  OnOpenSaleViewMode();
                }
                selfButton.prop('disabled', false);
              },
              errorCallback: function (response) {
                console.log('response', response);
                window.toast({
                  error: true,
                  text: "Erro ao gerar contrato!"
                })
                selfButton.prop('disabled', false);
              }
            })
          } else {
            selfButton.prop('disabled', false);
          }
        });
      } else if (type == 'conta_corrente') {

        if (contractGeneratorData.currentAccountService2.generate == true) {
          if (contractGeneratorData.currentAccountService2.serviceId == -1) {
            selfButton.prop('disabled', false);
            return window.toast({
              error: true,
              text: "Você deve informar o serviço do masso!"
            })
          }
          if (contractGeneratorData.currentAccountService2.doctorId == -1) {
            selfButton.prop('disabled', false);
            return window.toast({
              error: true,
              text: "Você deve informar o doutor do masso!"
            })
          }
          if (contractGeneratorData.currentAccountService2.servicePrice == 0) {
            selfButton.prop('disabled', false);
            return window.toast({
              error: true,
              text: "Você deve informar o valor unitário com desconto do serviço 2!"
            })
          }
        }

        Swal.fire({
          title: 'Geração de conta corrente',
          html: `
            Confirme os dados da conta corrente:<br><br>

            Nome do paciente: ${contractGeneratorData.patientName}<br>
            Serviço: ${contractGeneratorData.serviceName}<br>
            Valor total do serviço: ${float2moeda(contractGeneratorData.contractValue)}<br>
          `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, gerar conta corrente',
          cancelButtonText: 'Cancelar',
        }).then((result) => {
          if (result.isConfirmed) {
            //console.log('Gerar conta corrente');
            //selfButton.prop('disabled', false);
            //console.log('contractGeneratorData', contractGeneratorData);

            apiCall({
              endpoint: 'api/v1/sale/generate-service-asset',
              method: 'POST',
              data: {
                sale_id: viewSaleData.current.ID,
                type: type,
                data: contractGeneratorData,
              },
              successCallback: function (response) {
                //console.log('response', response);
                window.toast({
                  error: response.error,
                  text: response.message
                })
                if (response.error) {
                  selfButton.prop('disabled', false);
                } else {
                  //window.location.reload();
                  $('#modal-sale-generate-contract-or-individual-session').modal('hide');
                  OnOpenSaleViewMode();
                }
              },
              errorCallback: function (response) {
                console.log('response', response);
                window.toast({
                  error: true,
                  text: "Erro ao gerar conta corrente!"
                })
                selfButton.prop('disabled', false);
              }
            })
          } else {
            selfButton.prop('disabled', false);
          }
        });
      }
    });

    const checkForOverpriceInCurrentAccount = () => {
      if (viewSaleData.current.FILIAL_ID == 14) {
        if (contractGeneratorData.currentAccountService2.generate == true) {
          if ((Number(contractGeneratorData.currentAccountService2.servicePrice) + Number(contractGeneratorData.contractValue)) > Number($('#js-sale-generate-contract-or-individual-session-service-value').data('base-value'))) {
            console.log('true');
            return true;
          } else {
            console.log('false');
            return false;
          }
        }
      }
    }

    // Renderiza a lista de parcelas
    const renderContractInsertInstallments = () => {
      let html = '',
        totalPaidInAccessionDate = 0,
        totalFutureToPay = 0;
      contractGeneratorData.installments.forEach((installment, index) => {
        console.log(moment(installment.DATA_PAGAMENTO).format('YYYY-MM-DD'), moment($('.js-sale-generate-contract-or-individual-session-admission-date').val()).format('YYYY-MM-DD'))
        if (moment(installment.DATA_PAGAMENTO).format('YYYY-MM-DD') == moment($('.js-sale-generate-contract-or-individual-session-admission-date').val()).format('YYYY-MM-DD')) {
          totalPaidInAccessionDate = parseFloat(totalPaidInAccessionDate) + parseFloat(installment.VALOR_TOTAL);
        } else {
          totalFutureToPay = parseFloat(totalFutureToPay) + parseFloat(installment.VALOR_TOTAL);
        }

        html += `
          <tr>
              <td data-label="Ações">
                  <button class="btn btn-danger js-contract-insert-installments-remove" type="button" data-installment-id="${installment.ID}">
                      <i class="fas fa-trash"></i>
                  </button>
              </td>
              <td data-label="Forma de Pagamento">${getPaymentMethod(installment.FORMA_PAGAMENTO)}</td>
              <td data-label="Data de Pagamento">${installment.DATA_PAGAMENTO}</td>
              <td data-label="Quantidade de Parcelas">${installment.QT_PARCELAS}</td>
              <td data-label="Valor da Parcela">${installment.VALOR_PARCELA}</td>
              <td data-label="Valor Total">${installment.VALOR_TOTAL}</td>
              <td data-label="Observação">${installment.OBSERVACAO}</td>
          </tr>
        `;
      });

      let sumTotalPaidValues = 0; // Inicializa como número
      let contractTotal = contractGeneratorData.contractValue;
      if (contractGeneratorData.installments.length > 0) {
        contractGeneratorData.installments.forEach(installment => {
          sumTotalPaidValues += parseFloat(installment.VALOR_TOTAL); // Soma os valores como números
        });
      } else {
        window.toast({
          error: true,
          text: "Você deve cadastrar todas formas de pagamento e devem somar R$ " + contractTotal + "!"
        })
      }
      //sumTotalPaidValues += parseFloat($('#contract_insert_installments_total').val());
      sumTotalPaidValues = parseFloat(sumTotalPaidValues).toFixed(2); // Converte para string com 2 decimais apenas no final

      console.log('sumTotalPaidValues', sumTotalPaidValues, contractTotal);

      if (Number(sumTotalPaidValues) < Number(contractTotal)) {
        $('.js-sale-generate-contract-or-individual-session-generate-contract-container').addClass('d-none');
        window.toast({
          error: true,
          text: "As formas de pagamento devem somar o valor à ser pago de R$ " + contractTotal + "!"
        })
      } else {
        $('.js-sale-generate-contract-or-individual-session-generate-contract-container').removeClass('d-none');
      }

      $('.js-sale-generate-contract-or-individual-session-total-future-installments').html(`R$ ${float2moeda(totalFutureToPay)}`);
      $('.js-sale-generate-contract-or-individual-session-total-payment-methods').html(`R$ ${float2moeda(totalPaidInAccessionDate)}`);

      console.log('renderContractInsertInstallments', contractGeneratorData.installments);
      return html;
    }
  }

  // Detecta clique no botão para adicionar nota na fila de emissão
  const handleSaleInvoiceEmissionQueue = () => {
    $(document).on('click', '.js-sale-invoice-emission-queue', function (e) {
      isViewingInvoiceQueue.current = !isViewingInvoiceQueue.current;
      if (isViewingInvoiceQueue.current) {
        OnViewInvoiceQueue();
      } else {
        clearInterval(invoiceQueueInterval.current);
        if (invoiceQueueXHR.current) {
          invoiceQueueXHR.current.abort();
        }
        $('.js-sale-invoice-emission-queue-container').html('');
        $(".js-sale-invoice-emission-queue-container").unblock();
      }
    });

    apiCall({
      endpoint: 'api/v1/financial/invoice/queue-data',
      method: 'GET',
      successCallback: (response) => {
        if (!response.error) {
          if (response.data.statistics.erro > 0) {
            window.toast({
              error: true,
              text: "Existem notas fiscais com erro na fila de emissão! Por favor, verifique a fila de emissão."
            })
          }
        }
      },
      errorCallback: (err) => {
        console.error('error', err);
      }
    })
  }

  // Exibe a lista de notas fiscais na fila de emissão
  const OnViewInvoiceQueue = () => {
    $(".js-sale-invoice-emission-queue-container").block(window._loader.loading);
    loadInvoiceEmissionQueueData();
    invoiceQueueInterval.current = setInterval(() => {
      loadInvoiceEmissionQueueData();
    }, 30000);
  }

  // Carrega a lista de notas fiscais na fila de emissão
  const loadInvoiceEmissionQueueData = () => {
    if (invoiceQueueXHR.current) {
      invoiceQueueXHR.current.abort();
    }
    invoiceQueueXHR.current = apiCall({
      endpoint: 'api/v1/financial/invoice/queue-data',
      method: 'GET',
      successCallback: (response) => {
        console.log('response', response);
        $(".js-sale-invoice-emission-queue-container").unblock();
        const kanbanHTML = RenderInvoiceEmissionQueueKanbanBoard(response);
        $('.js-sale-invoice-emission-queue-container').html(kanbanHTML);
        invoiceQueueXHR.current = null;
      },
      errorCallback: (err) => {
        console.error('error', err);
        $(".js-sale-invoice-emission-queue-container").unblock();
        invoiceQueueXHR.current = null;
      }
    })
  }

  const RenderInvoiceEmissionQueueKanbanBoard = (data) => {
    if (!data || !data.data) {
      return (
        '<div class="d-flex justify-content-center align-items-center" style="min-height:200px">' +
        '<div class="text-center">' +
        '<div class="spinner-border text-primary" role="status">' +
        '<span class="visually-hidden">Carregando...</span>' +
        '</div>' +
        '<p class="mt-2 text-muted">Carregando dados da fila...</p>' +
        '</div>' +
        '</div>'
      );
    }

    const { branches, statistics } = data.data;

    if (!branches || branches.length === 0) {
      return (
        '<div class="d-flex justify-content-center align-items-center" style="min-height:300px">' +
        '<div class="text-center">' +
        '<i class="fas fa-check-circle text-success" style="font-size:4rem;margin-bottom:1rem"></i>' +
        '<h4 class="text-success mb-3">Nenhuma nota fiscal na fila!</h4>' +
        '<p class="text-muted">Todas as notas fiscais foram processadas com sucesso.</p>' +
        '</div>' +
        '</div>'
      );
    }

    const statsHtml = (
      '<div class="row mb-4">' +
      '<div class="col-md-3 col-sm-6 mb-3">' +
      '<div class="card border-warning">' +
      '<div class="card-body text-center">' +
      '<div class="d-flex align-items-center justify-content-center mb-2">' +
      '<i class="fas fa-clock text-warning me-2"></i>' +
      `<h5 class="card-title mb-0 text-warning">${statistics.aguardando || 0}</h5>` +
      '</div>' +
      '<p class="card-text small text-muted">Aguardando</p>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<div class="col-md-3 col-sm-6 mb-3">' +
      '<div class="card border-info">' +
      '<div class="card-body text-center">' +
      '<div class="d-flex align-items-center justify-content-center mb-2">' +
      '<i class="fas fa-cog text-info me-2"></i>' +
      `<h5 class="card-title mb-0 text-info">${statistics.emitindo || 0}</h5>` +
      '</div>' +
      '<p class="card-text small text-muted">Emitindo</p>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<div class="col-md-3 col-sm-6 mb-3">' +
      '<div class="card border-success">' +
      '<div class="card-body text-center">' +
      '<div class="d-flex align-items-center justify-content-center mb-2">' +
      '<i class="fas fa-check-circle text-success me-2"></i>' +
      `<h5 class="card-title mb-0 text-success">${statistics.emitidas || 0}</h5>` +
      '</div>' +
      '<p class="card-text small text-muted">Emitidas</p>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<div class="col-md-3 col-sm-6 mb-3">' +
      '<div class="card border-danger">' +
      '<div class="card-body text-center">' +
      '<div class="d-flex align-items-center justify-content-center mb-2">' +
      '<i class="fas fa-exclamation-triangle text-danger me-2"></i>' +
      `<h5 class="card-title mb-0 text-danger">${statistics.erro || 0}</h5>` +
      '</div>' +
      '<p class="card-text small text-muted">Erros</p>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>'
    );

    const cardsByBranch = (branches || []).map((branch) => {
      const cards = (branch.invoices || []).map((invoice) => {
        return `<div class="border-bottom p-3 invoice-card">${RenderInvoiceCardHTML(invoice)}</div>`;
      }).join('');

      return (
        '<div class="col mb-4" style="flex: 0 0 320px; min-width: 320px; max-width: 320px;">' +
        '<div class="card h-100">' +
        '<div class="card-header bg-light">' +
        '<div class="d-flex justify-content-between align-items-center">' +
        '<div>' +
        '<h6 class="mb-0">' +
        '<i class="fas fa-building text-primary me-2"></i>' +
        `${branch.FILIAL_NOME}` +
        '</h6>' +
        `<small class="text-muted">ID: ${branch.FILIAL_ID}</small>` +
        '</div>' +
        `<span class="badge bg-primary">${branch.total_invoices}</span>` +
        '</div>' +
        '</div>' +
        `<div class="card-body p-0" style="overflow-y:auto">${cards || ('<div class="text-center p-4 text-muted"><i class=\"fas fa-inbox fa-2x mb-2\"></i><p class=\"mb-0\">Nenhuma nota fiscal nesta filial</p></div>')}</div>` +
        '</div>' +
        '</div>'
      );
    }).join('');

    return `<div class="invoice-queue-kanban">${statsHtml}<div class="row flex-nowrap overflow-auto" style="max-width: 100%; overflow-x: auto;">${cardsByBranch}</div></div>`;
  }

  const RenderInvoiceCardHTML = (invoice) => {
    const getStatusConfig = (status) => {
      const configs = {
        'AGUARDANDO_FILA': { color: 'warning', icon: 'clock', text: 'Aguardando na Fila' },
        'EMITINDO': { color: 'info', icon: 'cog', text: 'Emitindo Nota' },
        'EMITIDA': { color: 'success', icon: 'check-circle', text: 'Nota Emitida' },
        'ERRO': { color: 'danger', icon: 'exclamation-triangle', text: 'Erro na Emissão' }
      };
      return configs[status] || configs['AGUARDANDO_FILA'];
    };

    const status = getStatusConfig(invoice.STATUS);
    const isProcessing = invoice.STATUS === 'EMITINDO';

    const formatDateTime = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    };

    const getErrorFromData = (dataString) => {
      if (!dataString) return '';
      try {
        const data = JSON.parse(dataString);
        return data.error || data.erro_timestamp || 'Erro desconhecido';
      } catch (e) {
        return 'Erro ao processar dados';
      }
    };

    return (
      '<div class="position-relative' + (isProcessing ? ' processing-card' : '') + '">' +
      (isProcessing
        ? '<div class="position-absolute top-0 end-0 me-2 mt-2"><div class="spinner-border spinner-border-sm text-info" role="status"><span class="visually-hidden">Processando...</span></div></div>'
        : '') +
      '<div class="d-flex justify-content-between align-items-start mb-2">' +
      `<div class="badge bg-${status.color} text-white">` +
      `<i class="fas fa-${status.icon} me-1"></i>` +
      `${status.text}` +
      '</div>' +
      '</div>' +
      '<div class="mb-2">' +
      `<strong class="text-dark">Nota:</strong> #${invoice.NOTA_ID}<br>` +
      `<strong class="text-dark">Venda:</strong> #${invoice.VENDA_ID}` +
      (invoice.CUSTOMER_NAME ? `<br><strong class="text-dark">Cliente:</strong> ${invoice.CUSTOMER_NAME}` : '') +
      (invoice.DADOS_PERSONALIZADOS ? '<br><small class="text-muted">Dados extras disponíveis</small>' : '') +
      '</div>' +
      (invoice.STATUS === 'ERRO' && invoice.DADOS_PERSONALIZADOS
        ? `<div class="alert alert-danger alert-sm mb-2"><i class="fas fa-exclamation-circle me-1"></i><small>${getErrorFromData(invoice.DADOS_PERSONALIZADOS)}</small></div>`
        : '') +
      '<div class="text-muted small">' +
      '<div class="d-flex align-items-center mb-1">' +
      '<i class="fas fa-clock me-1"></i>' +
      `<span>Inserido: ${formatDateTime(invoice.CRIADO_EM)}</span>` +
      '</div>' +
      (invoice.ATUALIZADO_EM && invoice.ATUALIZADO_EM !== invoice.CRIADO_EM
        ? '<div class="d-flex align-items-center">' +
        '<i class="fas fa-sync me-1"></i>' +
        `<span>Atualizado: ${formatDateTime(invoice.ATUALIZADO_EM)}</span>` +
        '</div>'
        : '') +
      '</div>' +
      '</div>'
    );
  }

  React.useEffect(() => {
    interval.current = setInterval(() => {
      if (window._sessionData.businessBranches && branches.length === 0) {
        initData();
      }
    }, 1000);

    tableRef.setFetchTableData(fetchTableData);
  }, []);

  React.useEffect(() => {
    //console.log('createSaleFormData', createSaleFormData.current);
  }, [createSaleFormData]);

  React.useEffect(() => {
    //console.log('createSaleCustomerData', createSaleCustomerData.current);
  }, [createSaleCustomerData]);

  return (
    <>
      <div className="col-12 p-2">
        <div className="row">
          <div className="col-12">
            <div className="w-100 border rounded-top bg-white shadow-sm" style={{ position: 'sticky', bottom: '-2rem' }}>
              <div className="row g-0">
                <div className="col-sm-12 col-md-4 p-3 border-end">
                  <div className="d-flex flex-column ml-2 justify-content-center">
                    <span className="text-muted small text-uppercase">Cancelados (<span className="js-sales-total-sales-canceled-count">0</span>)</span>
                    <h4 className="my-2 fw-bold text-danger">R$ <span className="js-sales-total-sales-canceled-value">0,00</span></h4>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4 p-3 border-end">
                  <div className="d-flex flex-column ml-2 justify-content-center">
                    <span className="text-muted small text-uppercase">Aprovados (<span className="js-sales-total-sales-approved-count">0</span>)</span>
                    <h4 className="my-2 fw-bold text-success">R$ <span className="js-sales-total-sales-approved-value">0,00</span></h4>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4 p-3 border-end">
                  <div className="d-flex flex-column ml-2 justify-content-center">
                    <span className="text-muted small text-uppercase">Total no período (<span className="js-sales-total-sales-period-count">0</span>)</span>
                    <h4 className="my-2 fw-bold text-info">R$ <span className="js-sales-total-sales-value">0,00</span></h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table id="table-sales-list" className="align-middle mb-0 table table-borderless table-striped table-hover responsive-table tbody-cursor-pointer">
          <thead>
            <tr>
              <th className="text-center"></th>
              <th data-label="Filial">Filial</th>
              <th data-label="Número">Número</th>
              <th data-label="Data">Data</th>
              <th data-label="Cliente">Cliente</th>
              <th data-label="Valor">Valor</th>
              <th data-label="Situação">Situação</th>
              <th data-label="Nota Fiscal">Nota Fiscal</th>
              <th data-label="Ações">Ações</th>
            </tr>
          </thead>
          <tbody className="js-sales-registrations-table">
            <tr>
              <td className="text-center" colspan="9">Carregando....</td>
            </tr>
          </tbody>
        </table>
        <hr className="divider" />
        <div className="d-flex bd-highlight border">
          <div className="p-2 flex-grow-1 bd-highlight"><h6>Total de vendas</h6></div>
          <div className="p-2 bd-highlight"><span className="text-info">Total (R$):</span><br /><span className="fs-4 fw-bold js-sales-total-sales-value">100,00</span></div>
        </div>
      </div>
    </>
  );
}

try {
  if (document.getElementById('js-sales-registrations-container')) {
    const container = document.getElementById('js-sales-registrations-container');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<PatientsReports />);
  }
} catch (err) {
  console.error('PatientsReports error', err);
}